/**
 * Svenska, typad mot en.ts. Ett antal är platshållaren `n` och har sin `.one`-form bredvid; en gräns är `min` eller
 * `max` och är aldrig 1. Granskas av en svensktalande kollega före lansering.
 */

import type { MessageKey } from './en'

export const sv: Record<MessageKey, string> = {
  'app.name': 'Pascal',
  'app.tagline': 'AI-familjens arbetstavla',
  'demo.banner': 'Demonstration: en påhittad organisation. Alla personer och namn här är påhittade.',

  'common.loading': 'Läser in…',
  'common.retry': 'Försök igen',
  'common.cancel': 'Avbryt',
  'common.optional': 'frivilligt',
  'common.fictional': 'påhittad',
  'common.notYet': 'Inte byggt ännu',

  'nav.main': 'Huvudmeny',
  'nav.skip': 'Hoppa till innehållet',
  'nav.board': 'Tavla',
  'nav.myWork': 'Mitt arbete',
  'nav.units': 'Enheter',
  'nav.people': 'Personer',
  'nav.admin': 'Organisation',
  'nav.about': 'Om Pascal',
  'nav.privacy': 'Integritet',
  'nav.signOut': 'Logga ut',
  'nav.language': 'Språk',
  'shell.signedInAs': 'Inloggad som {name}',

  'role.admin': 'Administratör',
  'role.member': 'Medlem',
  'role.guest': 'Gäst',
  'unit.kind.organisation': 'Organisation',
  'unit.kind.division': 'Division',
  'unit.kind.team': 'Team',
  'unit.role.lead': 'Ansvarig',
  'unit.role.member': 'Medlem',

  'explain.whatWentIn': 'Detta skickades till modellen',
  'explain.howComputed': 'Så räknades detta',

  'signIn.title': 'Logga in',
  'signIn.email': 'E-postadress',
  'signIn.password': 'Lösenord',
  'signIn.submit': 'Logga in',
  'signIn.busy': 'Loggar in…',
  'signIn.invited': 'Ny här? Använd länken i din inbjudan.',
  'signIn.forgot': 'Glömt lösenordet? Be en administratör i din organisation att återställa det.',

  'invite.noToken': 'Den här adressen behöver länken från din inbjudan.',
  'invite.title': 'Skapa ditt konto',
  'invite.resetTitle': 'Välj ett nytt lösenord',
  'invite.resetFor': 'Ett nytt lösenord för {email}.',
  'invite.org': 'Du är inbjuden till {org} som {role}.',
  'invite.unit': 'Ditt team: {unit} ({role}).',
  'invite.by': 'Inbjuden av {name}.',
  'invite.expires': 'Länken fungerar till {date}, en gång.',
  'invite.name': 'Ditt namn',
  'invite.password': 'Lösenord',
  'invite.passwordHint': 'minst 12 tecken',
  'invite.terms': 'Jag har läst integritetsinformationen.',
  'invite.create': 'Skapa konto',
  'invite.resetSubmit': 'Spara lösenord',


  'common.close': 'Stäng',
  'common.save': 'Spara',
  'board.title': 'Tavlor',
  'board.intro': 'Projekten du kan se, vart och ett med sin tavla. Öppna ett för att se vem som gör vad och vad som är försenat.',
  'board.none': 'Du ser inget projekt ännu. En projektledare lägger till dig, eller så öppnas ett projekt för hela organisationen. Att inget syns här betyder inte att inget pågår.',
  'board.visibilityNote': 'Du ser ett projekt när du är med i det, när det är öppet för organisationen eller när du leder enheten som äger det eller en enhet ovanför. Begränsade projekt ser bara deras medlemmar.',
  'board.all': 'Alla tavlor',
  'board.columns': 'Kolumner',
  'board.items': '{n} uppgifter',
  'board.items.one': '{n} uppgift',
  'board.late': '{n} försenade',
  'board.late.one': '{n} försenad',
  'board.keys': 'Tangentbord: Enter öppnar ett kort, M flyttar det, mellanslag lyfter det och piltangenterna bär det.',
  'board.viewerNote': 'Du läser tavlan som betraktare: du kan öppna varje kort men inte ändra något.',
  'board.readOnlyNote': 'Du ser tavlan på grund av din plats i organisationen, inte som medlem i projektet, så du kan läsa men inte ändra.',
  'board.guestNote': 'Som gäst flyttar och ändrar du bara kort som du utför eller har rapporterat.',
  'view.label': 'Vy',
  'view.board': 'Tavla',
  'view.list': 'Lista',
  'project.new': 'Nytt projekt',
  'project.name': 'Namn',
  'project.key': 'Nyckel',
  'project.keyHint': '2 till 6 versaler, till exempel AMLR: korten heter AMLR-1, AMLR-2 …',
  'project.ownerUnit': 'Ägs av',
  'project.visibility': 'Vem ser det',
  'project.restrictedToggle': 'Begränsat: misstänkt penningtvätt eller HR-ärenden',
  'project.restrictedHint': 'Bara medlemmarna ser det: ingen enhetschef, ingen administratör. Namnge aldrig en kund; använd ärendereferensen.',
  'project.defaultBoard': 'Projektet får en tavla med kolumnerna Backlogg, Att göra, Pågår, Granskning och Klar. Du blir projektledare.',
  'project.create': 'Skapa projekt',
  'project.restricted': 'Begränsat',
  'project.open': '{n} öppna',
  'project.open.one': '{n} öppen',
  'project.blocked': '{n} blockerade',
  'project.blocked.one': '{n} blockerad',
  'project.done': '{n} klara',
  'project.done.one': '{n} klar',
  'project.itemsHidden': 'Du ser projektets namn som administratör; dess kort är för medlemmarna.',
  'project.yourRole': 'Du: {role}',
  'projectRole.lead': 'projektledare',
  'projectRole.member': 'medlem',
  'projectRole.viewer': 'betraktare',
  'visibility.members': 'Projektets medlemmar',
  'visibility.organisation': 'Hela organisationen',
  'col.wipOf': '{n} av {max}',
  'col.wipOf.one': '{n} av {max}',
  'col.over': 'Över gränsen',
  'col.empty': 'Inga kort här.',
  'col.settings': 'Kolumner',
  'col.intro': 'Varje kolumn betyder ett fast steg (dess kategori); räkningar och klar-regeln läser steget, aldrig namnet. WIP-gränsen är hur många kort som får ligga i kolumnen innan den säger "Över gränsen".',
  'col.nameEn': 'Namn på engelska',
  'col.nameSv': 'Namn på svenska',
  'col.wip': 'WIP-gräns',
  'col.category': 'Steg: {category}',
  'col.categoryLabel': 'Steg',
  'col.earlier': 'Flytta {name} åt vänster',
  'col.later': 'Flytta {name} åt höger',
  'col.archive': 'Arkivera {name}',
  'col.archiveTitle': 'Arkivera kolumnen {name}?',
  'col.archiveExplain': 'Den tas bort från tavlan för gott: en arkiverad kolumn går inte att ta tillbaka. Den är tom, så inget kort flyttas.',
  'col.archiveConfirm': 'Arkivera',
  'col.new': 'Ny kolumn',
  'col.add': 'Lägg till kolumn',
  'col.added': 'Kolumnen lades till.',
  'col.saved': 'Sparat.',
  'category.intake': 'Föreslagen',
  'category.backlog': 'Backlogg',
  'category.ready': 'Redo',
  'category.active': 'Pågår',
  'category.review': 'Granskas',
  'category.done': 'Klar',
  'category.cancelled': 'Avbruten',
  'type.epic': 'Epos',
  'type.task': 'Uppgift',
  'type.subtask': 'Deluppgift',
  'type.control': 'Kontroll',
  'type.duty': 'Återkommande plikt',
  'type.remediation': 'Åtgärd',
  'type.change': 'Regeländring',
  'type.request': 'Förfrågan',
  'type.milestone': 'Milstolpe',
  'priority.low': 'Låg',
  'priority.normal': 'Normal',
  'priority.high': 'Hög',
  'priority.urgent': 'Brådskande',
  'outcome.achieved': 'Uppnått',
  'outcome.partly': 'Delvis uppnått',
  'outcome.not_achieved': 'Inte uppnått',
  'mode.person': 'Bara personer',
  'mode.ai': 'Bara AI-expert',
  'mode.pair': 'Par (person och AI)',
  'mode.none': 'Ingen ännu',
  'mode.short.person': 'Person',
  'mode.short.ai': 'AI',
  'mode.short.pair': 'Par',
  'mode.short.none': 'Ingen',
  'ai.houseRule': 'AI föreslår, en person bekräftar.',
  'ai.recordOnly': 'En AI-expert på ett kort är en uppgift om dess del: den föreslår, en person bekräftar. Pascal anropar ingen modell; experten arbetar i sin egen produkt och dess del förs in här för hand.',
  'performer.title': 'Utförare',
  'performer.list': 'Utförs av {names}',
  'performer.aiNamed': '{name} (AI-expert)',
  'performer.kind.person': 'Person',
  'performer.kind.ai_expert': 'AI-expert',
  'performer.kindLabel': 'Vem',
  'performer.person': 'Person',
  'performer.expert': 'AI-expert',
  'performer.roleLabel': 'Som',
  'performer.nobody': 'Ingen ännu',
  'performer.noExpert': 'Ingen AI-expert',
  'performer.none': 'Ingen utför kortet ännu.',
  'performer.add': 'Lägg till utförare',
  'performer.remove': 'Ta bort {name}',
  'performerRole.lead': 'ansvarig',
  'performerRole.assist': 'hjälper till',
  'performerRole.reviewer': 'granskar',
  'lane.label': 'Simbanor',
  'lane.none': 'Inga simbanor',
  'lane.person': 'Per person',
  'lane.mode': 'Efter vem som gör det (person, AI, par)',
  'lane.priority': 'Per prioritet',
  'lane.noPerson': 'Ingen person',
  'lane.named': 'Simbana: {name}',
  'filter.label': 'Filtrera korten',
  'filter.search': 'Sök',
  'filter.person': 'Person',
  'filter.anyone': 'Vem som helst',
  'filter.mode': 'Vem som gör det',
  'filter.anyMode': 'Personer, AI eller par',
  'filter.labelName': 'Etikett',
  'filter.anyLabel': 'Alla etiketter',
  'filter.unit': 'Team',
  'filter.anyUnit': 'Alla team',
  'filter.late': 'Bara försenade',
  'filter.showing': 'Visar {shown} av {n} uppgifter',
  'filter.showing.one': 'Visar {shown} av {n} uppgift',
  'card.label': '{code}: {title}',
  'dnd.card': 'kort',
  'dnd.instructions': 'Flytta ett kort med tangentbordet: tryck M och välj en kolumn, eller tryck mellanslag för att lyfta det, vänster- och högerpil för att bära det och mellanslag för att släppa. Escape avbryter. Enter öppnar kortet.',
  'dnd.picked': 'Lyfte {code}.',
  'dnd.over': '{code} är över {column}.',
  'dnd.notOver': 'Inte över någon kolumn.',
  'dnd.dropped': '{code} släpptes i {column}.',
  'dnd.cancelled': 'Flytten avbröts.',
  'dnd.moved': '{code} flyttades till {column}.',
  'move.menu': 'Flytta {code} till',
  'move.to': 'Flytta till {column}',
  // Undo instead of "Are you sure?", and the status in the row (tests/acceptance/ui-undo.ts)
  'undo.undo': 'Ångra',
  'undo.region': 'Senaste ändringen',
  'undo.announce': '{message} Ångra: Ctrl+Z, eller Ångra i meddelandet längst ned på skärmen.',
  'undo.priority': '{code}: prioritet {priority}.',
  'undo.undoneMove': 'Ångrat: {code} är tillbaka i {column}.',
  'undo.undonePriority': 'Ångrat: {code} har prioritet {priority} igen.',
  'reopen.title': 'Öppna {code} igen?',
  'reopen.explain': 'Bekräftelsen tas bort; historiken behåller den. Det går inte att ångra: för att bli klar igen måste en person bekräfta den med sitt utfall.',
  'reopen.explainSecond': 'Den andra personens kontroll tas också bort, och en andra person måste kontrollera den igen.',
  'reopen.confirm': 'Öppna igen',
  'reopen.bulkTitle': 'Öppna {n} klara uppgifter igen?',
  'reopen.bulkTitle.one': 'Öppna {n} klar uppgift igen?',
  'reopen.bulkExplain': 'Det här öppnar {n} klara uppgifter igen och tar bort deras bekräftelser; historiken behåller dem. Det går inte att ångra: för att bli klar igen måste en person bekräfta var och en med sitt utfall.',
  'reopen.bulkExplain.one': 'Det här öppnar {n} klar uppgift igen och tar bort dess bekräftelse; historiken behåller den. Det går inte att ångra: för att bli klar igen måste en person bekräfta den med sitt utfall.',
  'reopen.bulkList': 'De klara uppgifter som öppnas igen',
  'reopen.bulkSecond': 'Andra personers kontroller tas också bort, och en andra person måste kontrollera de uppgifterna igen.',
  'reopen.bulkOthers': '{n} andra valda uppgifter flyttas också.',
  'reopen.bulkOthers.one': '{n} annan vald uppgift flyttas också.',
  'reopen.bulkConfirm': 'Öppna igen och flytta',
  'inline.status': 'Status för {code}: {column}. Ändra',
  'inline.statusMenu': 'Status för {code}',
  'inline.priority': 'Prioritet för {code}: {priority}. Ändra',
  'inline.priorityMenu': 'Prioritet för {code}',
  'errors.UNDO_GONE': 'Det går inte längre att ångra: tiden har gått ut, eller kortet har ändrats sedan dess.',
  'item.loading': 'Öppnar kortet…',
  'item.new': 'Ny uppgift',
  'item.create': 'Skapa uppgift',
  'item.created': '{code} skapades.',
  'item.title': 'Rubrik',
  'item.description': 'Beskrivning',
  'item.descriptionHint': 'Namnge aldrig en kund i ett begränsat ärende; använd ärendereferensen.',
  'item.type': 'Typ',
  'item.column': 'Kolumn',
  'item.priority': 'Prioritet',
  'item.dueOn': 'Förfaller',
  'item.dueKind': 'Typ av datum',
  'item.due': 'Förfaller {date}',
  'item.dueHard': 'Sista dag {date}',
  'item.noDue': 'Inget förfallodatum',
  'item.overdue': 'Försenad',
  'item.daysLate': '{n} dagar sen',
  'item.daysLate.one': '{n} dag sen',
  'item.comments': '{n} kommentarer',
  'item.comments.one': '{n} kommentar',
  'item.labels': 'Etiketter',
  'item.labelsHint': 'Separerade med kommatecken, högst 10',
  'item.noLabels': 'Inga etiketter',
  'item.owner': 'Ansvarig',
  'item.noOwner': 'Ingen utsedd',
  'item.reportedBy': 'Rapporterad av {name}',
  'item.state': 'Läge',
  'item.edit': 'Redigera',
  'item.blocked': 'Blockerad',
  'item.block': 'Markera som blockerad',
  'item.unblock': 'Inte längre blockerad',
  'item.blockedReason': 'Varför är den blockerad?',
  'item.fourEyes': 'Fyra ögon',
  'item.controlTask': 'Kontrolluppgift',
  'item.fourEyesRule': 'klar först när en andra person, som varken utfört eller bekräftat den, har kontrollerat den.',
  'item.fourEyesDefault': 'En kontroll eller åtgärd är en kontrolluppgift: en andra person måste kontrollera den innan den är klar.',
  'item.controlToggle': 'Kontrolluppgift (fyra ögon)',
  'item.controlStays': 'Fyra ögon ligger kvar: bara ett administratörsbeslut med motivering stänger av det, och det finns inte ännu.',
  'due.soft': 'Internt mål',
  'due.hard': 'Lagstadgad eller extern sista dag',
  'done.title': 'Klar: {code}',
  'done.open': 'Klar…',
  'done.outcome': 'Hur gick det?',
  'done.confirm': 'Bekräfta klar',
  'done.youConfirm': 'Du registreras som den person som bekräftade.',
  'done.controlNote': 'Det här är en kontrolluppgift: en andra person måste bekräfta. Den väntar i granskning tills dess.',
  'done.confirmedBy': 'Bekräftad av {name}: {outcome}.',
  'done.secondBy': 'Andra kontroll av {name}.',
  'done.waitingSecond': 'Väntar på en andra person',
  'done.announce': '{code} bekräftades.',
  'second.title': 'Andra kontroll: {code}',
  'second.confirmedBy': '{name} bekräftade: {outcome}.',
  'second.explain': 'Du kontrollerar arbetet som andra person. Du har varken utfört eller bekräftat det. Efter din kontroll är kortet klart.',
  'second.record': 'Registrera andra kontrollen',
  'second.notYou': 'Du har utfört eller bekräftat kortet, så den andra kontrollen görs av någon annan.',
  'second.notWriter': 'En medlem i projektet som varken utfört eller bekräftat det gör den andra kontrollen.',
  'contribution.title': 'Vad AI-experterna gjorde',
  'contribution.intro': 'Införd av en person. En kostnad som ingen rapporterat lämnas tom.',
  'contribution.none': 'Inget är infört ännu.',
  'contribution.model': 'Modell: {model}',
  'contribution.noModel': 'Modell inte angiven',
  'contribution.noCost': 'Kostnad inte rapporterad',
  'contribution.cost': 'Kostnad US${cost}',
  'contribution.recordedBy': 'införd av {name}, {date}',
  'contribution.expert': 'AI-expert',
  'contribution.what': 'Vad den gjorde',
  'contribution.use': 'Hur resultatet användes',
  'contribution.modelLabel': 'Modell',
  'contribution.modelHint': 'Om du vet den, till exempel anthropic:claude-opus-5-5',
  'contribution.add': 'För in',
  'use.as_is': 'Användes som det var',
  'use.light_edit': 'Lätt redigerat',
  'use.heavy_edit': 'Kraftigt redigerat',
  'use.discarded': 'Användes inte',
  'use.unknown': 'Användning inte angiven',
  'docs.title': 'Dokument',
  'docs.intro': 'Länkar till där dokumenten finns. Pascal lagrar inga filer.',
  'docs.none': 'Inget dokument är länkat.',
  'docs.label': 'Namn',
  'docs.url': 'Adress (https)',
  'docs.urlPlaceholder': 'https://…',
  'docs.add': 'Lägg till länk',
  'docs.remove': 'Ta bort {label}',
  'links.title': 'Länkade uppgifter',
  'links.none': 'Ingen länkad uppgift.',
  'links.kind': 'Länk',
  'links.code': 'Uppgiftskod',
  'links.codePlaceholder': 'AMLR-12',
  'links.add': 'Länka',
  'links.blocks.out': 'Blockerar',
  'links.blocks.in': 'Blockeras av',
  'links.relates.out': 'Hör ihop med',
  'links.relates.in': 'Hör ihop med',
  'links.duplicates.out': 'Är en dubblett av',
  'links.duplicates.in': 'Har en dubblett i',
  'links.split_from.out': 'Utbruten ur',
  'links.split_from.in': 'Utbruten till',
  'comments.title': 'Kommentarer',
  'comments.none': 'Inga kommentarer ännu.',
  'comments.add': 'Kommentar',
  'comments.hint': 'Om arbetet, aldrig om en person.',
  'comments.send': 'Lägg till kommentar',
  'history.title': 'Historik',
  'history.intro': 'Skrivs av databasen vid varje ändring; ingen kan redigera den.',
  'history.someone': 'Någon som inte längre finns med',
  'history.bySystem': 'Pascal',
  'history.aPerson': 'en person',
  'history.oldColumn': 'en kolumn som inte längre finns på tavlan',
  'history.created': 'Skapad i {column}',
  'history.moved': 'Flyttad från {from} till {to}',
  'history.reopened': 'Öppnad igen, till {to}',
  'history.confirmed': 'Bekräftad klar: {outcome}',
  'history.secondPerson': 'Andra kontroll registrerad (fyra ögon)',
  'history.assigned': '{name} tillagd ({role})',
  'history.unassigned': '{name} borttagen',
  'history.blocked': 'Blockerad: {reason}',
  'history.unblocked': 'Inte längre blockerad',
  'history.commented': 'Kommentar tillagd',
  'history.linkAdded': 'Länk tillagd',
  'history.contribution': 'AI-bidrag från {name} infört',
  'history.fieldChanged': 'Ändrat: {fields}',
  'field.title': 'rubrik',
  'field.description': 'beskrivning',
  'field.priority': 'prioritet',
  'field.labels': 'etiketter',
  'field.due_on': 'förfallodatum',
  'field.due_kind': 'typ av datum',
  'field.owner_person_id': 'ansvarig person',
  'field.type': 'typ',
  'field.control_task': 'fyra ögon',
  'field.start_on': 'startdatum',
  'field.parent_id': 'överordnad uppgift',
  'list.caption': 'Korten på {name}',
  'list.code': 'Kod',
  'list.title': 'Rubrik',
  'list.column': 'Kolumn',
  'list.type': 'Typ',
  'list.priority': 'Prioritet',
  'list.due': 'Förfaller',
  'list.none': 'Inget kort matchar filtret.',
  'bulk.selected': '{n} valda',
  'bulk.selected.one': '{n} vald',
  'bulk.all': 'Välj alla kort som visas',
  'bulk.pick': 'Välj {code}',
  'bulk.choose': 'Välj…',
  'bulk.moveTo': 'Flytta till',
  'bulk.move': 'Flytta de valda',
  'bulk.priority': 'Prioritet',
  'bulk.setPriority': 'Sätt prioriteten',
  'bulk.doneNote': 'Klar bekräftas kort för kort, med sitt utfall (öppna kortet).',
  'bulk.result': 'Ändrade: {done} · nekade: {refused}',
  'myWork.title': 'Mitt arbete',
  'myWork.intro': 'Allt du utför eller ansvarar för, i alla dina projekt, efter förfallodatum.',
  'myWork.count': '{n} uppgifter för dig',
  'myWork.count.one': '{n} uppgift för dig',
  'myWork.late': 'Försenat',
  'myWork.week': 'Förfaller inom 7 dagar',
  'myWork.later': 'Senare',
  'myWork.noDue': 'Inget förfallodatum',
  'myWork.done': 'Klart de senaste 14 dagarna',
  'myWork.noneLate': 'Inget av ditt är försenat.',
  'myWork.noneHere': 'Inget här.',
  'myWork.fourEyes': 'Väntar på din andra kontroll (fyra ögon)',
  'myWork.fourEyesIntro': 'Kontrolluppgifter i dina projekt, bekräftade av någon annan, som du inte har utfört.',
  'myWork.what': 'Räknat: de öppna korten där du är utförare eller ansvarig, i de projekt du kan se.',
  'errors.FOUR_EYES': 'En andra person som varken utfört eller bekräftat uppgiften måste göra kontrollen.',
  'errors.FOUR_EYES_PENDING': 'Det här är en kontrolluppgift: en andra person måste kontrollera den innan den är klar.',
  'errors.FOUR_EYES_NEEDS_CONFIRM': 'Bekräfta uppgiften först; sedan kontrollerar en andra person den.',
  'errors.FOUR_EYES_OFF': 'Fyra ögon ligger kvar på den här uppgiften.',
  'errors.NOT_CONTROL_TASK': 'Bara en kontrolluppgift får en andra kontroll.',
  'errors.DONE_NEEDS_OUTCOME': 'Ange hur det gick innan den är klar.',
  'errors.DONE_NEEDS_CONFIRM': 'Klar kräver en person som bekräftar.',
  'errors.GUEST_OWN_ITEMS': 'Som gäst ändrar du bara uppgifter som du utför eller har rapporterat.',
  'errors.PROJECT_READ_ONLY': 'Du kan läsa projektet men inte ändra det.',
  'errors.PROJECT_LEAD_ONLY': 'Bara projektledaren gör detta.',
  'errors.PROJECT_LAST_LEAD': 'Ett projekt behåller minst en projektledare.',
  'errors.PROJECT_KEY': 'En projektnyckel är 2 till 6 versaler, till exempel AMLR.',
  'errors.PROJECT_KEY_TAKEN': 'Ett annat projekt har redan den nyckeln.',
  'errors.PROJECT_OWNER_UNIT': 'Ett projekt ägs av en aktiv enhet.',
  'errors.ITEM_COLUMN': 'Den kolumnen finns inte på kortets tavla.',
  'errors.ITEM_PARENT': 'En överordnad uppgift finns i samma projekt.',
  'errors.ITEM_CREATE_CLOSED': 'Ett kort skapas öppet och stängs efteråt.',
  'errors.LABELS': 'En etikett har 1 till 40 tecken, och ett kort har högst 10.',
  'errors.BLOCKED_REASON': 'Ange varför den är blockerad.',
  'errors.COLUMN_NOT_EMPTY': 'Flytta först ut korten ur kolumnen.',
  'errors.PERFORMER_NOT_MEMBER': 'En person utför kort i ett projekt där de arbetar.',
  'errors.CONTRIBUTION_PERFORMER': 'Ett bidrag hör till en AI-expert som utför kortet.',
  'errors.LINK_CYCLE': 'Då skulle korten blockera varandra i en cirkel.',
  'errors.URL_HTTPS': 'En länk börjar med https://.',
  'errors.BOARD_NO_REVIEW': 'Tavlan har ingen granskningskolumn.',
  'errors.BOARD_NO_DONE': 'Tavlan har ingen klar-kolumn.',
  'units.title': 'Enheter',
  'units.intro': 'Organisationen, dess divisioner och deras team. En division ligger under organisationen, ett team under en division.',
  'units.teams': '{n} team',
  'units.teams.one': '{n} team',
  'units.new': 'Ny enhet',
  'units.kind': 'Typ',
  'units.parent': 'Under',
  'units.name': 'Namn',
  'units.code': 'Kod',
  'units.codeHint': '2 till 8 versaler eller siffror, till exempel FCP',
  'units.create': 'Skapa enhet',
  'units.created': 'Enheten skapades.',
  'units.members': 'Medlemmar',
  'units.noMembers': 'Ingen hör till den här enheten ännu.',
  'units.archived': 'Arkiverad',
  'units.none': 'Det finns inga divisioner eller team ännu.',
  'units.adminOnly': 'Bara en administratör skapar och ändrar enheter.',

  'people.title': 'Personer',
  'people.count': '{n} personer',
  'people.count.one': '{n} person',
  'people.role': 'Roll',
  'people.homeTeam': 'Hemteam',
  'people.homeTeamNone': 'Inget team',
  'people.disabled': 'Avstängd',
  'people.invite': 'Bjud in en person',
  'people.email': 'E-postadress',
  'people.displayName': 'Namn',
  'people.unitRole': 'I teamet som',
  'people.inviteSend': 'Skapa inbjudan',
  'people.linkOnce': 'Skicka den här länken till personen. Den visas bara nu och fungerar en gång.',
  'people.waitsSecond': 'En andra administratör måste bekräfta inbjudan innan någon länk finns.',

  'invites.title': 'Väntande inbjudningar och återställningar',
  'invites.waiting': '{n} inbjudningar väntar',
  'invites.waiting.one': '{n} inbjudan väntar',
  'invites.kind.invite': 'Inbjudan',
  'invites.kind.reset': 'Återställning av lösenord',
  'invites.needsSecond': 'Väntar på en andra administratör',
  'invites.ready': 'Länk given',
  'invites.confirm': 'Bekräfta',
  'invites.none': 'Inget väntar.',

  'about.title': 'Om Pascal',
  'about.createdBy': 'Skapad av Daniel Bardun.',
  'about.version': 'Version {version}',
  'about.family': 'Pascal hör till AI-familjen: {names}.',
  'about.fonts': 'Typsnitt: Instrument Sans och Instrument Serif, under SIL Open Font License 1.1.',
  'about.developed': 'Utvecklad av Daniel Bardun enligt ANTON- och Alexander-ramverken och deras kunskapsupplägg.',
  'about.licensedUnder': 'Licensierad under',
  'about.licenceName': 'Europeiska unionens licens för fri programvara (EUPL) v1.2',
  'privacy.title': 'Integritet i arbetet',
  'privacy.draft': 'UTKAST, ännu inte granskat av en jurist.',
  'privacy.body': 'Pascal registrerar arbetet, inte personen. Vad som registreras om dig, och vem som ser det, skrivs ut här i sin helhet innan någon använder Pascal med riktiga personer.',
  'notFound.title': 'Hittades inte',
  'notFound.body': 'Det finns ingenting på den här adressen, eller ingenting du får se.',

  'errors.INTERNAL': 'Något gick fel. Försök igen, och säg till din administratör om det fortsätter.',
  'errors.UNREACHABLE': 'Servern gick inte att nå. Kontrollera anslutningen och försök igen.',
  'errors.UNAVAILABLE': 'Servern kunde inte kontrollera din session. Försök igen om en stund.',
  'errors.NOT_FOUND': 'Hittades inte.',
  'errors.FORBIDDEN': 'Du får inte göra detta.',
  'errors.ROLE_NEEDED': 'Det här kräver en annan roll.',
  'errors.CONFLICT': 'Det här finns redan.',
  'errors.INVALID': 'Det är inte giltigt.',
  'errors.SAME_ORIGIN': 'Begäran nekades eftersom den inte kom från den här webbplatsen.',
  'errors.SIGN_IN': 'Logga in först.',
  'errors.SESSION_ENDED': 'Din session har tagit slut. Logga in igen.',
  'errors.SIGN_IN_INPUT': 'Fyll i din e-postadress och ditt lösenord.',
  'errors.SIGN_IN_FAILED': 'E-postadressen och lösenordet stämmer inte med något konto.',
  'errors.LOCKED': 'För många misslyckade inloggningar för kontot från ditt nätverk. Försök igen om 15 minuter.',
  'errors.TOO_MANY': 'För många inloggningsförsök från den här adressen. Försök igen senare.',
  'errors.LINK_INVALID': 'Länken är inte giltig, eller så har den gått ut eller redan använts.',
  'errors.TEXT_REQUIRED': 'Fyll i texten som efterfrågas.',
  'errors.TEXT_TOO_SHORT': 'Skriv minst {min} tecken.',
  'errors.TEXT_TOO_LONG': 'Skriv högst {max} tecken.',
  'errors.PASSWORD_MISSING': 'Välj ett lösenord.',
  'errors.PASSWORD_SHORT': 'Välj ett lösenord på minst {min} tecken.',
  'errors.PASSWORD_LONG': 'Lösenordet är för långt: högst 72 byte.',
  'errors.UNIT_PARENT': 'En division ligger under organisationen och ett team under en division.',
  'errors.UNIT_HAS_CHILDREN': 'Arkivera först enheterna under den här.',
  'errors.UNIT_MEMBER_UNIT': 'En person går med i en aktiv division eller ett aktivt team.',
  'errors.ACCOUNT_EXISTS': 'Det finns redan ett konto med den här e-postadressen.',
  'errors.INVITE_EXISTS': 'En inbjudan till den här e-postadressen väntar redan. Dra tillbaka den först.',
  'errors.EMAIL_INVALID': 'Det är ingen e-postadress.',
  'errors.HOME_UNIT_TEAM': 'Ett hemteam måste vara ett aktivt team.',
  'errors.CONFIRM_SECOND_ADMIN': 'En andra administratör, inte den som frågade, bekräftar detta.',
  'errors.ADMIN_NEEDS_SECOND': 'En administratör tillkommer genom en inbjudan som en andra administratör bekräftar.',
  'errors.TERMS_NEEDED': 'Bekräfta att du har läst integritetsinformationen.',

  // ── P2: scrum och planering ────────────────────────────────────────────────────────────────────────────────
  'nav.fourEyes': 'Fyra ögon',
  'view.backlog': 'Backlogg',
  'view.reports': 'Rapporter',
  'lane.epic': 'Per epik',
  'lane.noEpic': 'Ingen epik',
  'filter.type': 'Typ',
  'filter.anyType': 'Alla typer',
  'filter.epic': 'Epik',
  'filter.anyEpic': 'Alla epiker',
  'filter.sprint': 'Sprint',
  'filter.anySprint': 'Alla sprintar',
  'filter.noSprint': 'Utan sprint (backloggen)',
  'filters.saved.label': 'Sparade filter',
  'filters.none': 'Inga sparade filter ännu',
  'filters.choose': 'Välj ett sparat filter',
  'filters.sharedName': '{name} (delat av {owner})',
  'filters.you': 'dig',
  'filters.remove': 'Ta bort filtret "{name}"',
  'filters.removed': 'Filtret "{name}" är borttaget.',
  'filters.saveThis': 'Spara det här filtret',
  'filters.saved': 'Filtret "{name}" är sparat.',
  'filters.name': 'Filtrets namn',
  'filters.share': 'Vem som ser det',
  'filters.shareMe': 'Bara jag',
  'filters.shareProject': 'Alla i projektet',
  'filters.typed': 'Ett sparat filter innehåller bara valen ovan. Det har aldrig någon egen sökning.',
  'boardSettings.title': 'Tavlan',
  'boardSettings.mode': 'Hur tavlan arbetar',
  'boardSettings.modeHint': 'Scrum lägger till sprintar: tavlan visar då den pågående sprinten.',
  'boardSettings.unit': 'Uppskattningar i',
  'boardSettings.unitHint': 'Timmar kan jämföras med den ungefärliga insats som anges vid klar; poäng är valfritt.',
  'boardSettings.saved': 'Tavlan är sparad.',
  'mode.board.kanban': 'Kanban',
  'mode.board.scrum': 'Scrum',
  'unit.hours': 'timmar',
  'unit.points': 'poäng',
  'estimate.title': 'Uppskattning',
  'estimate.hours': '{n} timmar',
  'estimate.hours.one': '1 timme',
  'estimate.points': '{n} poäng',
  'estimate.points.one': '1 poäng',
  'estimate.none': 'Ingen uppskattning',
  'estimate.inHours': 'Uppskattning (timmar)',
  'estimate.inPoints': 'Uppskattning (poäng)',
  'estimate.hint': 'Valfritt. Sparas som baslinje när arbetet börjar.',
  'estimate.baseline': 'Baslinje (låst när arbetet började)',
  'estimate.baselineIs': '{estimate} · {due} · sparad {date}',
  'estimate.noBaseline': 'Inte ännu: uppskattningen och förfallodagen sparas när arbetet börjar.',
  'estimate.reason': 'Varför uppskattningen ändras',
  'estimate.reasonHint': 'Beskriv arbetet, inte en person. Den första uppskattningen ligger kvar som den var.',
  'estimate.save': 'Spara uppskattningen',
  'estimate.calibLow': 'Dina tidigare uppskattningar var ungefär {pct} % för låga; kalibrerat: {hours}',
  'estimate.calibHigh': 'Dina tidigare uppskattningar var ungefär {pct} % för höga; kalibrerat: {hours}',
  'estimate.calibBasis': 'Utifrån {n} av dina klara uppgifter. Bara du ser det här.',
  'estimate.calibBasis.one': 'Utifrån 1 av dina klara uppgifter. Bara du ser det här.',
  'estimate.calibApply': 'Fyll i {hours}',
  'estimate.calibFilled': 'Ifyllt, inte sparat. Ändra om du vill och spara sedan.',
  'plan.title': 'Planering',
  'sprint.label': 'Sprint',
  'sprint.state.planned': 'Planerad',
  'sprint.state.active': 'Pågår',
  'sprint.state.closed': 'Avslutad',
  'sprint.items': '{n} uppgifter',
  'sprint.items.one': '1 uppgift',
  'sprint.noEstimate': '{n} uppgifter saknar uppskattning',
  'sprint.noEstimate.one': '1 uppgift saknar uppskattning',
  'sprint.start': 'Starta sprinten',
  'sprint.started': 'Sprinten har startat. Dess åtagande sparas som det är nu.',
  'sprint.close': 'Avsluta sprinten',
  'sprint.closeTitle': 'Avsluta {name}',
  'sprint.closeOpen': '{n} uppgifter är inte klara. De flyttas till sprinten du väljer, eller tillbaka till backloggen.',
  'sprint.closeOpen.one': '1 uppgift är inte klar. Den flyttas till sprinten du väljer, eller tillbaka till backloggen.',
  'sprint.closeNote': 'De klara uppgifterna stannar i sprinten. Dess register, åtagandet och det som blev klart, ändras inte efteråt.',
  'sprint.leftoversTo': 'De öppna uppgifterna flyttas till',
  'sprint.startFreezes': 'När sprinten startar sparas dess åtagande: de öppna uppgifterna i den och deras uppskattningar.',
  'sprint.committedLine': 'Åtagande vid starten: {amount} i {n} uppgifter.',
  'sprint.committedLine.one': 'Åtagande vid starten: {amount} i 1 uppgift.',
  'sprint.empty': 'Ingen uppgift i sprinten ännu. Planera in uppgifter från backloggen nedan.',
  'sprint.new': 'Ny sprint',
  'sprint.name': 'Namn',
  'sprint.defaultName': 'Sprint {n}',
  'sprint.defaultName.one': 'Sprint 1',
  'sprint.goal': 'Sprintmål',
  'sprint.goalHint': 'Valfritt: vad sprinten är till för, i en mening.',
  'sprint.goalIs': 'Mål: {goal}',
  'sprint.startOn': 'Börjar',
  'sprint.endOn': 'Slutar',
  'sprint.lengthHint': 'Högst sex veckor. Startdagen blir den dag du startar den.',
  'sprint.create': 'Skapa sprinten',
  'sprint.closedCount': '{n} avslutade sprintar: se Rapporter.',
  'sprint.closedCount.one': '1 avslutad sprint: se Rapporter.',
  'sprint.planInto': 'Sprint',
  'sprint.planFor': 'Sprint för {code}',
  'sprint.running': 'Pågår: {name}, till {to}',
  'sprint.noneRunning': 'Ingen sprint pågår. Planera och starta en i backloggen.',
  'sprint.showAll': 'Visa alla uppgifter, inte bara sprinten',
  'backlog.title': 'Backlogg',
  'backlog.intro': 'De öppna uppgifterna utan sprint, i backloggens ordning. Den översta kommer först.',
  'backlog.empty': 'Ingen öppen uppgift utanför en sprint. Här räknas ingenting, så det betyder inte att allt är klart.',
  'epic.title': 'Epiker',
  'epic.progress': '{done} av {n} uppgifter klara',
  'epic.progress.one': '{done} av 1 uppgift klar',
  'epic.left': 'kvar: {amount}',
  'epic.tag': 'Epik {code}',
  'ready.label': 'Redo att börja',
  'ready.yes': 'Redo: uppskattning och någon som gör den',
  'ready.missing': 'Inte redo: saknar {what}',
  'ready.estimate': 'uppskattning',
  'ready.performer': 'någon som gör den',
  'rank.group': 'Ordning för {code}',
  'rank.top': 'Flytta {code} överst',
  'rank.up': 'Flytta {code} uppåt',
  'rank.down': 'Flytta {code} nedåt',
  'rank.bottom': 'Flytta {code} längst ned',
  'rank.short.top': 'Överst',
  'rank.short.up': 'Upp',
  'rank.short.down': 'Ned',
  'rank.short.bottom': 'Sist',
  'rank.said.top': '{code} ligger överst.',
  'rank.said.up': '{code} flyttades uppåt.',
  'rank.said.down': '{code} flyttades nedåt.',
  'rank.said.bottom': '{code} ligger längst ned.',
  'rank.moved': '{code} flyttades.',
  'rank.draggable': 'uppgift i backloggen',
  'rank.dragHint': 'Dra till en annan uppgift för att lägga den ovanför. Med tangentbordet använder du knapparna.',
  'subitems.title': 'Deluppgifter',
  'subitems.parent': 'Under:',
  'subitems.noParent': 'ingenting (en uppgift på översta nivån)',
  'subitems.none': 'Inga deluppgifter.',
  'subitems.count': '{n} deluppgifter',
  'subitems.count.one': '1 deluppgift',
  'subitems.progress': '{done} av {n} deluppgifter klara',
  'subitems.progress.one': '{done} av 1 deluppgift klar',
  'subitems.add': 'Ny {type} under den här',
  'subitems.create': 'Lägg till',
  'subitems.moveUnder': 'Lägg under uppgiften',
  'subitems.moveUnderHint': 'Dess kod, till exempel AMLR-4. Lämna tomt för att göra den till en uppgift på översta nivån.',
  'subitems.setParent': 'Flytta den dit',
  'subitems.under': 'Deluppgift till {code}:',
  'reports.intro': 'Tavlans siffror, var och en från en versionerad regel, med vad den räknade. Ingen av dem handlar om en person.',
  'reports.period': 'Klara under',
  'reports.lastDays': 'de senaste {n} dagarna',
  'reports.lastDays.one': 'den senaste dagen',
  'reports.periodLine': 'Klara från {from} till {to}: {n} uppgifter.',
  'reports.periodLine.one': 'Klara från {from} till {to}: 1 uppgift.',
  'reports.sprint': 'Sprint',
  'reports.noneDone': 'inget klart under perioden',
  'reports.noneDoneHonest': 'Ingen uppgift blev klar under perioden, så det finns inget att bedöma. Det betyder inte "allt i tid".',
  'ontime.title': 'I tid',
  'ontime.summary': 'I tid: {onTime} av {n} uppgifter med förfallodag ({noDue} saknade en)',
  'ontime.summary.one': 'I tid: {onTime} av 1 uppgift med förfallodag ({noDue} saknade en)',
  'ontime.late': '{n} uppgifter försenade',
  'ontime.late.one': '1 uppgift försenad',
  'ontime.early': '{n} uppgifter klara före förfallodagen (räknas som i tid)',
  'ontime.early.one': '1 uppgift klar före förfallodagen (räknas som i tid)',
  'ontime.moved': '{n} uppgifter fick förfallodagen flyttad efter att arbetet började; mot den nuvarande dagen var {onTime} av {withDue} i tid',
  'ontime.moved.one': '1 uppgift fick förfallodagen flyttad efter att arbetet började; mot den nuvarande dagen var {onTime} av {withDue} i tid',
  'ontime.noBaseline': '{n} uppgifter blev klara innan Pascal sparade baslinjer och räknas inte',
  'ontime.noBaseline.one': '1 uppgift blev klar innan Pascal sparade baslinjer och räknas inte',
  'ontime.perPerson': 'Här finns ingen siffra för i tid per person.',
  'ontime.item.onTime': 'Klar i tid (mot förfallodagen som sparades när arbetet började).',
  'ontime.item.early': 'Klar {n} dagar före förfallodagen som sparades när arbetet började.',
  'ontime.item.early.one': 'Klar 1 dag före förfallodagen som sparades när arbetet började.',
  'ontime.item.late': 'Klar {n} dagar efter förfallodagen som sparades när arbetet började.',
  'ontime.item.late.one': 'Klar 1 dag efter förfallodagen som sparades när arbetet började.',
  'ontime.item.noDue': 'Den hade ingen förfallodag när arbetet började, så den bedöms inte.',
  'ontime.item.noBaseline': 'Klar innan Pascal sparade baslinjer, så den bedöms inte.',
  'ontime.item.currentOnTime': 'Förfallodagen flyttades: mot den nuvarande dagen var den i tid.',
  'ontime.item.currentLate': 'Förfallodagen flyttades: mot den nuvarande dagen var den försenad.',
  'cycle.title': 'Flödestider',
  'cycle.lead': 'Från skapad till klar',
  'cycle.cycle': 'Från att arbetet började till klar',
  'cycle.waiting': 'Väntan (i granskning eller blockerad)',
  'cycle.spread': 'median {median} dagar, 85 % inom {p85} dagar ({n} uppgifter)',
  'cycle.spread.one': 'median {median} dagar, 85 % inom {p85} dagar (1 uppgift)',
  'cycle.never': '{n} uppgifter blev klara utan att ha pågått och har ingen tid från att arbetet började',
  'cycle.never.one': '1 uppgift blev klar utan att ha pågått och har ingen tid från att arbetet började',
  'cycle.item': 'Från skapad till klar: {lead}. Från att arbetet började: {cycle}. Väntan: {waiting}.',
  'cycle.notInProgress': 'pågick aldrig',
  'cycle.noHistory': 'Dess historik visar inte vägen till klar.',
  'days.count': '{n} dagar',
  'days.count.one': '1 dag',
  'flow.title': 'Hur det gick',
  'velocity.title': 'Hastighet',
  'velocity.teamFigure': 'En siffra för teamet, aldrig per person.',
  'velocity.none': 'Ingen sprint är avslutad ännu, så det finns ingen hastighet att visa.',
  'velocity.chart': 'Åtagande och klart per sprint, i {unit}',
  'velocity.committed': 'Åtagande vid starten',
  'velocity.done': 'Klart vid avslutet',
  'velocity.mean': 'I genomsnitt {mean} klart per sprint, över {n} sprintar.',
  'velocity.otherUnit': 'Avslutade sprintar som inte räknas eftersom de mättes i en annan enhet: {n}.',
  'velocity.otherUnit.one': 'En avslutad sprint räknas inte eftersom den mättes i en annan enhet.',
  'velocity.mean.one': 'I genomsnitt {mean} klart per sprint, över 1 sprint.',
  'burn.sectionTitle': 'En sprint, dag för dag',
  'burn.title': 'Nedbränning',
  'burn.remaining': 'Kvar',
  'burn.ideal': 'Jämn takt till noll',
  'burn.start': 'Start',
  'burn.dates': '{from} till {to}',
  'burn.notStarted': 'Sprinten har inte startat, så det finns ingen linje ännu.',
  'burn.committed': 'Åtagande vid starten: {amount}',
  'burn.added': 'Tillagt efter starten: {n} uppgifter, {amount}',
  'burn.added.one': 'Tillagt efter starten: 1 uppgift, {amount}',
  'burn.removed': 'Borttaget efter starten: {n} uppgifter, {amount}',
  'burn.removed.one': 'Borttaget efter starten: 1 uppgift, {amount}',
  'burn.reestimated': 'Ändring från omuppskattningar: {amount}',
  'burn.doneRemaining': 'Klart: {done}. Kvar: {remaining}.',
  'burnup.title': 'Uppbränning',
  'burnup.done': 'Klart',
  'burnup.scope': 'Omfattning (klart och kvar)',
  'chart.table': 'Visa som tabell',
  'chart.seeTable': '{title}. Siffrorna finns i tabellen under diagrammet.',
  'chart.day': 'Dag',
  'chart.sprint': 'Sprint',
  'chart.notYet': 'inte ännu',
  'rule.how': 'Så räknades detta',
  'rule.ontime': 'En klar uppgift är i tid när dagen den blev klar är samma dag som eller före förfallodagen som sparades när arbetet började (baslinjen). Uppgifter som då saknade förfallodag räknas för sig och ingår inte i andelen; det gör inte heller uppgifter som blev klara innan baslinjer sparades. En uppgift vars förfallodag flyttades bedöms också mot den nuvarande dagen. Bara uppgifter som blev klara under den valda perioden räknas.',
  'rule.cycle': 'Ur varje klar uppgifts historik: från skapad till klar, från första gången den pågick till klar, och tiden den väntade i granskning eller var blockerad (varje stund en gång). Dagar om 24 timmar. Medianen är det mittersta värdet; 85 % av uppgifterna låg inom den andra siffran. Bara uppgifter som blev klara under den valda perioden räknas.',
  'rule.burn': 'Ur åtagandet som sparades vid starten och historiken efter den: för varje dag uppskattningarna av sprintens öppna uppgifter (kvar) och av dess klara uppgifter (klart). Uppgifter som lades till eller togs bort efter starten, och omuppskattningar, räknas för sig. En uppgift utan uppskattning räknas som noll och räknas för sig. Dagar som inte har kommit ritas inte.',
  'rule.velocity': 'För var och en av de sex senaste avslutade sprintarna: uppskattningarna som togs med vid starten och uppskattningarna av uppgifterna som var klara vid avslutet, i tavlans enhet. Genomsnittet gäller de visade sprintarna. Det beskriver teamets arbete, aldrig en person.',
  'comments.edit': 'Redigera',
  'comments.editLabel': 'Din kommentar',
  'comments.edited': 'redigerad',
  'comments.remove': 'Ta bort',
  'comments.removeConfirm': 'Ta bort din kommentar? Den försvinner från kortet; granskningsloggen behåller den.',
  'comments.removed': 'En kommentar som togs bort av den som skrev den.',
  'history.baselineSet': 'Arbetet började: baslinjen sparades ({estimate}, {due})',
  'history.estimateChanged': 'Uppskattades om från {from} till {to}',
  'history.sprintChanged': 'Flyttades från {from} till {to}',
  'history.commentEdited': 'Redigerade en kommentar',
  'history.commentRemoved': 'Tog bort en kommentar',
  'history.aSprint': 'en sprint',
  'history.reason': 'Varför: {reason}',
  'item.fourEyesWaived': 'En administratör har stängt av fyra ögon för den här typen: en ny uppgift av den behöver ingen andra person. Du kan ändå slå på det.',
  'fourEyes.title': 'Fyra ögon',
  'fourEyes.intro': 'Kontroll- och åtgärdsuppgifter behöver en andra person innan de är klara. Bara en administratör, med ett skäl, stänger av det för en typ.',
  'fourEyes.now': 'Nu',
  'fourEyes.onFor': 'På: en andra person kontrollerar varje ny uppgift av den här typen.',
  'fourEyes.offFor': 'Av sedan {date}, beslutat av {name}: {reason}',
  'fourEyes.newOnly': 'Ett beslut gäller uppgifter som skapas efter det. En uppgift som har fyra ögon behåller det.',
  'fourEyes.decide': 'Stäng av fyra ögon för en typ',
  'fourEyes.type': 'Typ',
  'fourEyes.reason': 'Varför',
  'fourEyes.reasonHint': 'Minst {min} tecken. Alla i organisationen kan läsa det.',
  'fourEyes.warning': 'Tillsynen förväntar sig oberoende kontroller av kontrollarbete. Skriv vad som kontrollerar arbetet i stället.',
  'fourEyes.turnOff': 'Stäng av fyra ögon',
  'fourEyes.decided': 'Beslutet är registrerat.',
  'fourEyes.end': 'Slå på fyra ögon igen för {type}',
  'fourEyes.endReason': 'Varför (valfritt)',
  'fourEyes.ended': 'Fyra ögon gäller igen för nya uppgifter.',
  'fourEyes.adminOnly': 'Bara en administratör fattar det här beslutet.',
  'fourEyes.history': 'Tidigare beslut',
  'fourEyes.past': '{type}: av från {from} till {to}. Beslutat av {name}, avslutat av {ender}: {reason}',
  'fourEyes.endedBecause': 'Avslutat därför att: {reason}',
  'errors.ESTIMATE_REASON': 'Arbetet har börjat, så den första uppskattningen sparas. Skriv varför uppskattningen ändras.',
  'errors.SPRINT_ACTIVE_EXISTS': 'Tavlan har en pågående sprint. Avsluta den innan du startar en till.',
  'errors.SPRINT_EMPTY': 'Planera in minst en öppen uppgift i sprinten innan du startar den.',
  'errors.SPRINT_CLOSED': 'Den sprinten är avslutad. Välj en öppen sprint eller backloggen.',
  'errors.SPRINT_RECORD': 'En avslutad sprint behåller arbetet som gjordes i den. Öppna uppgiften igen först för att planera om den.',
  'errors.SPRINT_BOARD': 'En sprint innehåller uppgifter från sin egen tavla.',
  'errors.SPRINT_PLANNER': 'Sprintar planeras av projektets ledare och medlemmar.',
  'errors.SPRINT_LENGTH': 'En sprint slutar på eller efter sin start, inom sex veckor, och inte i det förflutna.',
  'errors.SPRINT_FROZEN': 'En pågående sprint behåller sina datum och sitt åtagande, och en avslutad ändras inte.',
  'errors.SPRINT_STATE': 'En sprint går från planerad till pågående till avslutad.',
  'errors.SPRINT_LEFTOVERS': 'De öppna uppgifterna flyttas till en planerad sprint på tavlan, eller tillbaka till backloggen.',
  'errors.FILTER_SHAPE': 'Ett sparat filter innehåller bara tavlans filterval.',
  'errors.FILTER_SHARE_WRITER': 'Bara projektets ledare och medlemmar delar ett filter med projektet. Behåll det för dig själv.',
  'errors.COMMENT_AUTHOR_ONLY': 'Bara den som skrev en kommentar ändrar eller tar bort den.',
  'errors.COMMENT_REMOVED': 'Den kommentaren är borttagen.',
  'errors.FOUR_EYES_RULE_EXISTS': 'Fyra ögon är redan avstängt för den här typen.',
  'errors.ITEM_PARENT_CYCLE': 'En uppgift kan inte läggas under en av sina egna deluppgifter.',
  // ── P3: the learning fields ────────────────────────────────────────────────────────────────────────────
  'nav.learning': 'Lärande',
  'nav.atWork': 'Pascal på jobbet',
  'view.retro': 'Retrospektiv',
  'fun.title': 'Hur det kändes för dig',
  'fun.before.question': 'Hur engagerande tror du att det här arbetet kommer att kännas för dig?',
  'fun.after.question': 'Hur engagerande kändes det här arbetet för dig?',
  'fun.onlyYou': 'Hur kändes det för dig? (bara du ser detta)',
  'fun.1': 'Dränerande',
  'fun.2': 'Tråkig',
  'fun.3': 'Neutral',
  'fun.4': 'Rolig',
  'fun.5': 'Energigivande',
  'fun.skip': 'Hoppa över',
  'fun.privateNote': 'Bara du ser dina svar. Det handlar om själva arbetet, inte om hur bra det gick och inte om kollegor. Hoppa över när du vill.',
  'fun.sameAnswer': 'Ditt svar räknas också in i publicerade gruppsiffror. Om alla i en grupp ger samma svar visar siffran det svaret.',
  'fun.whoSees': 'Vem som ser vad',
  'fun.promptsOff': 'Du har stängt av frågan om hur det känns. Slå på den igen under Mitt arbete.',
  'fun.saved': 'Ditt svar är sparat. Bara du ser det.',
  'fun.removed': 'Ditt svar är raderat.',
  'fun.beforeLabel': 'Förväntat (före)',
  'fun.afterLabel': 'Upplevt (efter)',
  'fun.small': 'Färre än 5 personer: visas inte',
  'fun.smallMin': 'Färre än {min} personer: visas inte',
  'fun.protect': 'Visas inte, så att en mindre grupp inte kan räknas fram ur de andra siffrorna.',
  'fun.noRatings': 'Inga svar än.',
  'fun.mean': 'Medel {mean} av 5',
  'fun.people': '{n} personer',
  'fun.people.one': '1 person',
  'fun.ratings': '{n} svar',
  'fun.ratings.one': '1 svar',
  'fun.distribution': 'Hur svaren fördelar sig på de fem stegen',
  'fun.aggregateTitle': 'Hur arbetet kändes, som grupp',
  'fun.gapUp': 'Arbetet kändes {gap} bättre än förväntat.',
  'fun.gapDown': 'Arbetet kändes {gap} sämre än förväntat.',
  'fun.retroTitle': 'Hur arbetet kändes för teamet',
  'fun.aggregateNote': 'Visas bara för minst 5 personer och 5 svar. Ingens eget svar visas någonsin här.',
  'fun.theSprint': 'Sprintens arbete',
  'fun.sprintNotClosed': 'Hur arbetet kändes visas när sprinten är avslutad, så att ingen kan se siffran ändras när en person svarar.',
  'fun.byTeamElsewhere': 'På en kanbantavla visas hur arbetet kändes per team under Lärande.',
  'fun.byTeamTitle': 'Hur arbetet kändes, per team',
  'fun.byTeamIntro': 'Visas för perioder som har tagit slut. Personer räknas i sitt hemteam. Ett team med färre än 5 visar ingenting för sig; dess svar räknas i divisionen ovanför.',
  'fun.unit': 'Team, division eller organisation',
  'fun.period': 'Period',
  'fun.periodYear': 'Året {year}',
  'fun.periodQuarter': 'Kvartal {q} {year}',
  'fun.groupBy': 'Gruppera',
  'fun.by.none': 'Allt tillsammans',
  'fun.by.type': 'Per typ av arbete',
  'fun.by.mode': 'Per utförare: personer, AI eller par',
  'fun.everything': 'Allt arbete',
  'radar.title': 'Svårighetsradar',
  'radar.onCard': 'Svårighet bedömd',
  'radar.intro': 'Varje axel från 0 ingen till 4 extrem. Radarn beskriver arbetet, inte personen. Hoppa över en axel om du vill.',
  'radar.aboutItem': 'Radarn beskriver arbetet, inte personen: projektets medlemmar ser den.',
  'radar.before': 'Före',
  'radar.after': 'Efter',
  'radar.beforeLegend': 'Svårighet före: hur svårt ser det ut nu?',
  'radar.afterLegend': 'Svårighet efter: hur svårt var det?',
  'radar.axis': 'Axel',
  'radar.skip': 'Hoppa över',
  'radar.skipHint': 'Inte bedömd.',
  'radar.skipped': 'inte bedömd',
  'radar.none': 'Ingen har bedömt svårigheten än.',
  'radar.chartTitle': 'Svårighet för {code}',
  'radar.rateBefore': 'Bedöm svårigheten',
  'radar.editBefore': 'Ändra radarn före',
  'radar.rateAfter': 'Bedöm svårigheten efteråt',
  'radar.editAfter': 'Ändra radarn efter',
  'radar.save': 'Spara radarn',
  'radar.saved': 'Radarn är sparad.',
  'radar.profileTitle': 'Svårighetsprofil',
  'radar.profileNone': 'Ingen klar uppgift i perioden har en radar.',
  'radar.profileCounted': 'Från {n} klara uppgifter med radar (efter om den finns, annars före).',
  'radar.profileCounted.one': 'Från 1 klar uppgift med radar (efter om den finns, annars före).',
  'radar.mean': 'Medel',
  'radar.gap': 'Efter minus före',
  'radar.meanOf': '{mean} ({n} uppgifter)',
  'radar.meanOf.one': '{mean} (1 uppgift)',
  'radar.gapNote': 'Skillnaden gäller de {n} uppgifter som bedömdes både före och efter. En positiv siffra: svårare än det såg ut.',
  'radar.gapNote.one': 'Skillnaden gäller den 1 uppgift som bedömdes både före och efter. En positiv siffra: svårare än det såg ut.',
  'radar.point.0': 'Ingen',
  'radar.point.1': 'Låg',
  'radar.point.2': 'Medel',
  'radar.point.3': 'Hög',
  'radar.point.4': 'Extrem',
  'radar.axis.knowledge': 'Kunskap',
  'radar.question.knowledge': 'Hur mycket sak- eller regelkunskap krävs?',
  'radar.anchor.knowledge.0': 'Ingen särskild kunskap: vem som helst i teamet kan göra det.',
  'radar.anchor.knowledge.1': 'Grundläggande kunskap om våra egna rutiner.',
  'radar.anchor.knowledge.2': 'God kunskap om de regler som gäller.',
  'radar.anchor.knowledge.3': 'Specialistkunskap: en av våra experter.',
  'radar.anchor.knowledge.4': 'Expertis vi inte har internt, eller en ny lag.',
  'radar.axis.tech': 'Teknik',
  'radar.question.tech': 'Hur mycket teknisk kunskap eller verktygsvana krävs?',
  'radar.anchor.tech.0': 'Inga verktyg utöver de vanliga kontorsverktygen.',
  'radar.anchor.tech.1': 'Ett system vi använder varje dag.',
  'radar.anchor.tech.2': 'Viss inställning, en fråga mot data eller en kalkylmodell.',
  'radar.anchor.tech.3': 'Arbete i ett systems inställningar eller data, tillsammans med IT.',
  'radar.anchor.tech.4': 'Ett nytt verktyg, en integration eller kod.',
  'radar.axis.invention': 'Nytänkande',
  'radar.question.invention': 'Hur nytt är det för oss? Finns det en mall eller ett tidigare exempel?',
  'radar.anchor.invention.0': 'Gjort många gånger, med mall.',
  'radar.anchor.invention.1': 'Gjort förut: ett gammalt exempel att följa.',
  'radar.anchor.invention.2': 'Delvis nytt: vissa delar saknar exempel.',
  'radar.anchor.invention.3': 'Nytt för oss, men gjort på andra håll.',
  'radar.anchor.invention.4': 'Nytt för oss och för området: inget exempel någonstans.',
  'radar.axis.business': 'Verksamhet',
  'radar.question.business': 'Hur mycket affärsmässigt omdöme och påverkan handlar det om?',
  'radar.anchor.business.0': 'Inget verksamhetsbeslut och ingen påverkan utanför teamet.',
  'radar.anchor.business.1': 'En liten påverkan på en process.',
  'radar.anchor.business.2': 'Påverkar kunder eller ett annat team.',
  'radar.anchor.business.3': 'Ett beslut för ledningen, med verkliga kostnader.',
  'radar.anchor.business.4': 'Formar verksamheten: styrelsen beslutar.',
  'radar.axis.uncertainty': 'Osäkerhet',
  'radar.question.uncertainty': 'Hur tydligt är det från början vad ”klart” betyder?',
  'radar.anchor.uncertainty.0': 'Klart är tydligt och nedskrivet.',
  'radar.anchor.uncertainty.1': 'Mestadels tydligt: någon detalj att reda ut.',
  'radar.anchor.uncertainty.2': 'Målet är tydligt, vägen dit är det inte.',
  'radar.anchor.uncertainty.3': 'Själva målet måste arbetas fram.',
  'radar.anchor.uncertainty.4': 'Ingen kan ännu säga hur klart ser ut.',
  'radar.axis.dependencies': 'Beroenden',
  'radar.question.dependencies': 'Hur mycket beror det på andra personer, team, leverantörer eller data?',
  'radar.anchor.dependencies.0': 'Teamet kan göra det självt.',
  'radar.anchor.dependencies.1': 'Ett underlag från ett annat team.',
  'radar.anchor.dependencies.2': 'Flera underlag, eller en leverantör.',
  'radar.anchor.dependencies.3': 'Väntar på andra team eller leverantörer i flera steg.',
  'radar.anchor.dependencies.4': 'Kan inte gå framåt utan parter vi inte styr över.',
  'radar.axis.regulatory': 'Regelrisk',
  'radar.question.regulatory': 'Vad blir följden om det blir fel: en överträdelse, en anmärkning, en sanktion?',
  'radar.anchor.regulatory.0': 'Ingen följd i regelhänseende.',
  'radar.anchor.regulatory.1': 'Som mest en intern anmärkning.',
  'radar.anchor.regulatory.2': 'En anmärkning från revisorerna eller andra linjen.',
  'radar.anchor.regulatory.3': 'En överträdelse som tillsynsmyndigheten skulle bry sig om.',
  'radar.anchor.regulatory.4': 'En sanktion, eller skada för kunder eller marknaden.',
  'radar.axis.stakeholders': 'Intressenter',
  'radar.question.stakeholders': 'Hur många måste vara överens, och hur svårt är det att enas?',
  'radar.anchor.stakeholders.0': 'Ingen annan behöver godkänna.',
  'radar.anchor.stakeholders.1': 'En person godkänner.',
  'radar.anchor.stakeholders.2': 'Några personer, som oftast är överens.',
  'radar.anchor.stakeholders.3': 'Många personer, eller några som inte är överens.',
  'radar.anchor.stakeholders.4': 'Många parter med motstridiga intressen.',
  'problems.title': 'Problemlogg',
  'problems.none': 'Inget problem registrerat på uppgiften.',
  'problems.noneInPeriod': 'Inget problem registrerat i perioden. Det är inte samma sak som att inga inträffade.',
  'problems.count': '{n} problem',
  'problems.count.one': '1 problem',
  'problems.byCategory': '{category}: {n}',
  'problems.byCategory.one': '{category}: 1',
  'problems.statusLine': 'Öppna: {open} · lösta: {solved} · accepterade: {accepted}',
  'problem.blameFree': 'Beskriv vad som hände med arbetet. Nämn eller bedöm ingen person.',
  'problem.add': 'Registrera ett problem',
  'problem.update': 'Uppdatera',
  'problem.save': 'Spara problemet',
  'problem.saved': 'Problemet är sparat.',
  'problem.what': 'Vad som hände',
  'problem.category': 'Typ av problem',
  'problem.howArose': 'Hur det uppstod',
  'problem.howFound': 'Hur det upptäcktes',
  'problem.timeLost': 'Förlorad tid',
  'problem.timeLostNotSaid': 'Inte angivet',
  'problem.status': 'Status',
  'problem.howSolved': 'Hur det löstes',
  'problem.solvedBy': 'Löst av',
  'problem.choose': 'Välj',
  'problem.prevent': 'Vad skulle förhindra det nästa gång?',
  'problem.foundOn': 'upptäckt {date}',
  'problem.howAroseIs': 'Hur det uppstod: {text}',
  'problem.howSolvedIs': 'Löst {by}: {text}',
  'problem.preventIs': 'Nästa gång: {text}',
  'problem.cat.unclear_scope': 'Otydlig omfattning',
  'problem.cat.missing_input': 'Saknat underlag',
  'problem.cat.waiting_on_others': 'Väntan på andra',
  'problem.cat.tool_or_tech': 'Verktyg eller teknik',
  'problem.cat.ai_output_wrong': 'Fel i AI-svar',
  'problem.cat.knowledge_gap': 'Kunskapslucka',
  'problem.cat.scope_change': 'Ändrad omfattning',
  'problem.cat.regulatory_change': 'Regeländring',
  'problem.cat.data_quality': 'Datakvalitet',
  'problem.cat.capacity': 'Kapacitet',
  'problem.cat.other': 'Annat',
  'problem.found.self': 'Av oss själva',
  'problem.found.four_eyes_review': 'Vid fyraögonkontrollen',
  'problem.found.ai_check': 'Vid en AI-kontroll',
  'problem.found.stakeholder': 'Av en intressent',
  'problem.found.audit_or_supervisor': 'Av revisionen eller tillsynsmyndigheten',
  'problem.found.monitoring': 'Genom övervakning',
  'problem.found.other': 'På annat sätt',
  'problem.lost.lt_1h': 'Under en timme',
  'problem.lost.h1_4': '1 till 4 timmar',
  'problem.lost.d05_1': 'En halv till en dag',
  'problem.lost.d1_3': '1 till 3 dagar',
  'problem.lost.gt_3d': 'Mer än 3 dagar',
  'problem.statusIs.open': 'Öppet',
  'problem.statusIs.solved': 'Löst',
  'problem.statusIs.accepted': 'Accepterat (vi lever med det)',
  'problem.by.person': 'av en person',
  'problem.by.ai': 'av AI',
  'problem.by.pair': 'av en person och AI tillsammans',
  'problem.by.not_solved': 'inte löst',
  'done.effort': 'Ungefärlig insats',
  'done.notTimesheet': 'En ungefärlig siffra för lärandet. Det här är ingen tidrapport.',
  'done.yourEstimate': 'Din uppskattning: {n} timmar.',
  'done.yourEstimate.one': 'Din uppskattning: 1 timme.',
  'done.yourEstimatePoints': 'Din uppskattning: {n} poäng.',
  'done.yourEstimatePoints.one': 'Din uppskattning: 1 poäng.',
  'done.noEstimate': 'Det fanns ingen uppskattning.',
  'done.effortSkip': 'Hoppa över',
  'done.effortUpTo': 'Upp till {n} timmar',
  'done.effortUpTo.one': 'Upp till 1 timme',
  'done.effortOther': 'Mer, eller en annan siffra',
  'done.effortHours': 'Timmar, ungefär',
  'done.radar': 'Svårighet efteråt (valfritt)',
  'done.radarFromBefore': 'Svårighet efteråt, utifrån före (valfritt)',
  'done.problems': 'Något problem värt att registrera?',
  'done.problemAdd': 'Lägg till ett problem',
  'done.problemRemove': 'Ta bort det här problemet',
  'done.aiHelp': 'AI-stöd: hur användes det?',
  'done.aiUsed': '{expert}: {what}',
  'done.aiNotSaid': 'Inte angivet',
  'done.lesson': 'Lärdom: vad skulle vi göra annorlunda?',
  'record.title': 'Hur det gick: lärdomarna',
  'record.firstTimeRight': 'Rätt första gången',
  'record.ftrYes': 'Ja: den gick aldrig tillbaka från granskning eller klar.',
  'record.ftrNo': 'Nej: den gick tillbaka {n} gånger.',
  'record.ftrNo.one': 'Nej: den gick tillbaka en gång.',
  'record.actual': 'Ungefärlig insats',
  'record.aiShare': 'Andel gjord med AI-stöd',
  'record.lesson': 'Lärdom',
  'record.quality': 'Kvalitetsnotering',
  'record.notSaid': 'Inte registrerat',
  'record.edit': 'Ändra',
  'record.save': 'Spara',
  'record.saved': 'Lärdomarna är sparade.',
  'aiShare.none': 'Ingen',
  'aiShare.some': 'En del',
  'aiShare.most': 'Det mesta',
  'aiShare.all': 'Allt',
  'retro.intro': 'Vad sprinten (eller perioden) lärde oss: problem, lärdomar, i tid, rätt första gången och AI-stöd. Teamets siffror, aldrig en persons.',
  'retro.sprint': 'Sprint',
  'retro.byPeriod': 'En period i stället',
  'lessons.title': 'Lärdomar',
  'lessons.none': 'Ingen lärdom registrerad.',
  'lessons.count': '{n} lärdomar',
  'lessons.count.one': '1 lärdom',
  'rework.title': 'Rätt första gången',
  'rework.summary': 'Rätt första gången: {ftr} av {n} klara uppgifter',
  'rework.summary.one': 'Rätt första gången: {ftr} av 1 klar uppgift',
  'rework.moves': 'Steg tillbaka från granskning eller klar: {n}',
  'rework.moves.one': 'Steg tillbaka från granskning eller klar: 1',
  'aiuse.title': 'AI-stöd',
  'aiuse.none': 'Inget AI-bidrag registrerat.',
  'aiuse.count': '{n} AI-bidrag registrerade.',
  'aiuse.count.one': '1 AI-bidrag registrerat.',
  'aiuse.use': '{use}: {n}',
  'aiuse.use.one': '{use}: 1',
  'aiuse.notSaid': 'Inte angivet hur det användes: {n}',
  'aiuse.notSaid.one': 'Inte angivet hur det användes: 1',
  'aiuse.cost': 'Rapporterad kostnad: {usd} USD för {n} bidrag.',
  'aiuse.cost.one': 'Rapporterad kostnad: {usd} USD för 1 bidrag.',
  'aiuse.costNotReported': 'Kostnad inte rapporterad för {n}.',
  'aiuse.costNotReported.one': 'Kostnad inte rapporterad för 1.',
  'completeness.title': 'Vad de klara uppgifterna registrerade',
  'completeness.actual': 'Faktisk insats registrerad på {k} av {n} klara uppgifter',
  'completeness.actual.one': 'Faktisk insats registrerad på {k} av 1 klar uppgift',
  'completeness.radar': 'Svårighet efteråt bedömd på {k} av {n} klara uppgifter',
  'completeness.radar.one': 'Svårighet efteråt bedömd på {k} av 1 klar uppgift',
  'completeness.lesson': 'En lärdom registrerad på {k} av {n} klara uppgifter',
  'completeness.lesson.one': 'En lärdom registrerad på {k} av 1 klar uppgift',
  'completeness.why': 'Alla lärandefält är valfria, så de här visar hur mycket siffrorna ovan vilar på.',
  'mix.title': 'Vem som gjorde arbetet',
  'mix.line': '{mode}: {k} av {n} klara uppgifter ({share} %)',
  'mix.line.one': '{mode}: {k} av 1 klar uppgift ({share} %)',
  'learning.title': 'Lärande',
  'learning.intro': 'Vad arbetet lär oss: i tid, flöde, rätt första gången, problem, svårighet, vem som gjorde det och hur AI hjälpte till. Med vad varje siffra räknade.',
  'learning.noRanking': 'Ingen vy rangordnar personer. Det finns inget prestationsbetyg.',
  'learning.whoSeesWhat': 'Vad Pascal registrerar om dig, och vem som ser det',
  'learning.workTitle': 'Arbetet i ett projekt',
  'learning.project': 'Projekt',
  'learning.noProjects': 'Det finns inget projekt vars uppgifter du kan se.',
  'learning.doneInPeriod': '{n} uppgifter klara i perioden.',
  'learning.doneInPeriod.one': '1 uppgift klar i perioden.',
  'rule.rework': 'Från varje klar uppgifts historik: varje steg från granskning eller klar tillbaka till en tidigare kolumnkategori räknas en gång (också en återöppning); ett steg till avbruten gör det inte. Rätt första gången är en klar uppgift utan något sådant steg. Bara uppgifter klara i vald period eller sprint räknas.',
  'rule.problems': 'Problemen som registrerats i perioden (efter dagen de upptäcktes), räknade per typ, förlorad tid, status och vem som löste dem. Texterna visas för projektets medlemmar; vem som registrerade ett problem visas aldrig.',
  'rule.radar': 'För varje klar uppgift radarn efter om den finns, annars radarn före; medelvärdet per axel över de uppgifter som bedömde den. Skillnaden är efter minus före, över uppgifterna som bedömdes båda gångerna.',
  'rule.mix': 'Varje klar uppgifts utförare som de är nu: bara personer, ett par (en person och en AI-expert), bara en AI-expert (en person bekräftade ändå) eller ingen angiven. Andelar i hela procent.',
  'rule.aiuse': 'AI-bidragen som registrerats på uppgifterna, räknade efter hur en person sa att resultatet användes. Kostnaden är summan av rapporterade kostnader; ett bidrag utan kostnad räknas som ”kostnad inte rapporterad”, aldrig som noll.',
  'rule.fun': 'Databasen räknar svaren i en grupp och visar den bara när minst 5 personer och 5 svar finns i den. När en grupps siffra, dragen från en större, skulle lämna färre än 5 personer döljs den också. Personer räknas i sitt hemteam; den som har slutat räknas inte. Medelvärdet gäller de fem stegen.',
  'you.title': 'Du',
  'you.onlyYou': 'Bara du ser detta',
  'you.funTitle': 'Hur ditt arbete kändes',
  'you.noRatings': 'Du har inte svarat på frågan om hur det känns än.',
  'you.before': 'Förväntat: medel {mean} av 5 över {n} svar',
  'you.before.one': 'Förväntat: medel {mean} av 5 över 1 svar',
  'you.after': 'Upplevt: medel {mean} av 5 över {n} svar',
  'you.after.one': 'Upplevt: medel {mean} av 5 över 1 svar',
  'you.beforeNone': 'Förväntat: inget svar än',
  'you.afterNone': 'Upplevt: inget svar än',
  'you.gapUp': 'Ditt arbete kändes {gap} bättre än du väntade dig ({n} uppgifter).',
  'you.gapUp.one': 'Ditt arbete kändes {gap} bättre än du väntade dig (1 uppgift).',
  'you.gapDown': 'Ditt arbete kändes {gap} sämre än du väntade dig ({n} uppgifter).',
  'you.gapDown.one': 'Ditt arbete kändes {gap} sämre än du väntade dig (1 uppgift).',
  'you.mostEnergising': 'Ditt mest energigivande slags arbete: {type}',
  'you.ontimeTitle': 'Ditt arbete i tid',
  'you.noneDone': 'Du har inte gjort klart någon uppgift de senaste 12 månaderna.',
  'you.ontimeOnlyYou': 'Uppgifterna du utfört de senaste 12 månaderna. Bara du ser den här siffran; ingen chef har en vy över den.',
  'you.prompts': 'Frågan om hur det känns',
  'you.promptsOn': 'Pascal frågar hur du tror att arbetet ska kännas och hur det kändes. Du kan alltid hoppa över.',
  'you.promptsOffNow': 'Avstängd: Pascal frågar dig inte.',
  'you.turnOff': 'Sluta fråga mig',
  'you.turnOn': 'Fråga mig igen',
  'you.saved': 'Sparat.',
  'you.ratingsTitle': 'Dina svar ({n})',
  'you.ratingsTitle.one': 'Ditt svar (1)',
  'you.itemGone': 'En uppgift du inte längre ser',
  'you.remove': 'Radera',
  'you.showAll': 'Visa alla {n}',
  'you.showAll.one': 'Visa det 1 svaret',
  'you.showFewer': 'Visa färre',
  'you.eraseAll': 'Radera alla mina svar',
  'you.eraseAllConfirm': 'Radera alla svar du har gett? Det går inte att ångra.',
  'you.eraseAllYes': 'Ja, radera dem',
  'you.erasedAll': 'Alla dina svar är raderade.',
  'you.retention': 'Dina svar sparas i 24 månader och raderas sedan. Du kan radera dem när som helst.',
  'atWork.title': 'Pascal på jobbet: vad som registreras om dig',
  'atWork.intro': 'Pascal registrerar hur arbetet går så att team kan lära sig. Det handlar om arbetet, inte om dig som person. Den här sidan beskriver vad som registreras, vem som ser det och vad du kan välja.',
  'atWork.records.title': 'Vad som registreras',
  'atWork.records.items': 'Arbetsuppgifterna du utför, äger, rapporterar, bekräftar eller kontrollerar, med datum och historik.',
  'atWork.records.fun': 'Om du svarar: hur engagerande du trodde att ett arbete skulle kännas och hur det kändes, på en skala från 1 till 5. Varje svar är frivilligt.',
  'atWork.records.radar': 'En uppgifts svårighet på åtta axlar. Den beskriver arbetet, inte personen.',
  'atWork.records.problems': 'Problem i arbetet: vad som hände, hur det upptäcktes och löstes. Utan skuld: ingen namnges på ett problem.',
  'atWork.records.effort': 'En ungefärlig siffra för insatsen, om någon anger den. Det är ingen tidrapport och används aldrig för lön eller fakturering.',
  'atWork.records.ai': 'Vilken AI-expert som hjälpte till och hur resultatet användes.',
  'atWork.whoSees.title': 'Vem som ser vad',
  'atWork.col.what': 'Vad',
  'atWork.col.you': 'Du',
  'atWork.col.members': 'Projektets medlemmar',
  'atWork.col.leads': 'Enhetschefer',
  'atWork.col.admins': 'Administratörer',
  'atWork.row.ownFun': 'Dina egna svar om hur det kändes',
  'atWork.row.funGroups': 'En grupps svar om hur det kändes',
  'atWork.row.ownOntime': 'Om dina egna uppgifter blev klara i tid',
  'atWork.row.items': 'Uppgifter, utförare, utfall, radar',
  'atWork.row.problems': 'Problemtexter',
  'atWork.row.effort': 'Ungefärlig insats',
  'atWork.yes': 'Ja',
  'atWork.no': 'Nej',
  'atWork.group5': 'Bara för minst 5 personer',
  'atWork.ifVisible': 'Om de kan se projektet',
  'atWork.metadata': 'Projektets namn och antal; uppgifterna bara om de kan se projektet',
  'atWork.yesNoName': 'Ja, utan vem som registrerade dem',
  'atWork.never.title': 'Vad Pascal aldrig gör',
  'atWork.never.score': 'Det finns inget prestationsbetyg för en person, och ingen knapp för att slå på ett.',
  'atWork.never.rank': 'Ingen vy rangordnar personer. Det finns ingen ”bästa medarbetare”.',
  'atWork.never.ai': 'Ingen AI bedömer dig, föreslår vem som ska göra arbete utifrån din historik eller fattar beslut om dig.',
  'atWork.never.timesheet': 'Pascal är ingen tidrapportering: ingen stämpelklocka, ingen tid per person i en status.',
  'atWork.never.small': 'Ingen ser en grupps svar om hur det kändes när gruppen har färre än 5 personer, eller när en mindre grupp skulle kunna räknas fram ur siffrorna.',
  'atWork.choices.title': 'Vad du kan välja',
  'atWork.choices.skip': 'Hoppa över vilken fråga som helst: bara utfallet för en klar uppgift krävs.',
  'atWork.choices.off': 'Stänga av frågan om hur det känns, under Mitt arbete.',
  'atWork.choices.delete': 'Radera dina svar om hur det kändes, ett eller alla, när som helst, under Mitt arbete.',
  'atWork.choices.export': 'Ladda ner alla dina uppgifter: det kommer i en senare version av Pascal.',
  'atWork.retention.title': 'Hur länge det sparas',
  'atWork.retention.fun': 'Svar om hur det kändes: 24 månader efter svaret, sedan raderas de.',
  'atWork.retention.leaver': 'När du slutar: ditt konto stängs av, och dina svar om hur det kändes raderas 30 dagar senare.',
  'atWork.retention.work': 'Arbetsuppgifter (uppgifter, problem, radar): så länge projektet finns och 5 år efter att det avslutats, som verksamhetsdokumentation.',
  'atWork.legal.title': 'Den rättsliga ramen, i korthet',
  'atWork.draft': 'Utkast: behöver juridisk granskning.',
  'atWork.legal.gdpr': 'Dataskyddsförordningen gäller: din arbetsgivare är personuppgiftsansvarig, och leverantören av Pascal behandlar uppgifterna för dess räkning.',
  'atWork.legal.basis': 'Den rättsliga grunden är arbetsgivarens berättigade intresse av att planera och följa upp arbetet, inte ditt samtycke; frågan om hur det känns förblir frivillig.',
  'atWork.legal.dpia': 'Din arbetsgivare gör en konsekvensbedömning avseende dataskydd innan Pascal används med riktiga personer.',
  'atWork.legal.mbl': 'En arbetsgivare med kollektivavtal förhandlar med facket innan Pascal införs (11 § MBL) och håller facket informerat (19 §).',
  'atWork.legal.aiAct': 'Pascals AI bedömer inte personer och fördelar inte arbete utifrån deras beteende, vilket håller den utanför AI-förordningens högriskanvändning i arbetslivet.',
  'atWork.yourPanel': 'Dina egna siffror och svar finns i panelen ”Du” under',
  'errors.FUN_NOT_YOUR_WORK': 'Bara de som utför, äger eller bekräftar uppgiften anger hur den kändes.',
  'errors.FUN_AFTER_NEEDS_CONFIRM': 'Hur det kändes efteråt frågas när uppgiften är bekräftad.',
  'errors.FUN_BEFORE_NEEDS_OPEN': 'Hur du tror att det ska kännas frågas medan arbetet pågår.',
  'errors.RADAR_AFTER_NEEDS_CONFIRM': 'Radarn efteråt fylls i när uppgiften är bekräftad.',
  'errors.RADAR_EMPTY': 'Ange minst en axel, eller stäng utan att spara.',
  'errors.PROBLEM_HOW_SOLVED': 'Skriv hur problemet löstes och av vem: en person, AI eller båda.',
  'errors.PROBLEM_FOUND_ON': 'Ett problem upptäcks i dag eller tidigare.',
  'errors.FUN_AGGREGATE_ROLE': 'Gruppsiffror är till för organisationens medlemmar.',
  'errors.FUN_AGGREGATE_PERIOD': 'Välj ett kalenderår eller kvartal.',
  'errors.FUN_AGGREGATE_SHAPE': 'Välj ett team och hur det ska grupperas.',
  'errors.FUN_AGGREGATE_OPEN': 'Siffror visas för en period som har tagit slut, eller en sprint som är avslutad.',
  // ── P4a: the layers and the published figures ─────────────────────────────────────────────────────────────
  'nav.layers': 'Nivåer',
  'layers.title': 'Nivåer: organisationen, dess divisioner och team',
  'layers.intro': 'Två sätt att summera arbetet. Gjort av personer här: det arbete som enhetens personer utför, i vilket projekt som helst. Arbete i projekt som ägs här: arbetet i enhetens projekt, vem som än gör det. De skiljer sig när personer hjälper andra enheter.',
  'layers.counted': 'Räknat: varje öppen uppgift, och varje uppgift som blev klar från {from} till {to}, i de projekt som du ser.',
  'layers.up': 'Upp till {name}',
  'layers.open': 'Öppna den här nivån',
  'layers.orgPath': 'Gjort av personer här',
  'layers.orgPathNote': 'Arbete som personer med sitt hemteam här utför, i vilket projekt som helst. En uppgift som personer från två team gör räknas i båda, så teamen summerar inte till sin division.',
  'layers.projectPath': 'Arbete i projekt som ägs här',
  'layers.projectPathNote': 'Arbete i de projekt som den här enheten, eller en enhet under den, äger, vem som än gör det.',
  'layers.unseen': '{n} projekt som du inte ser',
  'layers.unseen.one': '1 projekt som du inte ser',
  'layers.unseenRestricted': '{n} av dem begränsade',
  'layers.unseenRestricted.one': '1 av dem begränsat',
  'layers.unseenCounts': 'öppna {open}, försenade {late}, klara under perioden {done}. Inte med i siffrorna ovan; inget namn visas.',
  'layers.smallMin': 'Färre än {min} personer: visas inte',
  'layers.protect': 'Visas inte, så att en mindre grupp inte kan räknas fram ur de andra siffrorna.',
  'layers.nothing': 'Inget öppet eller nyligen klart arbete räknas här.',
  'layers.fig.open': 'Öppna',
  'layers.fig.blocked': 'Blockerade',
  'layers.fig.late': 'Försenade (öppna efter förfallodagen)',
  'layers.fig.done': 'Klara under perioden',
  'layers.fig.throughput': 'Klara per vecka',
  'layers.fig.ontime': 'I tid',
  'layers.fig.people': 'Personer',
  'layers.ontimeOf': '{on} av {of} klara uppgifter med förfallodag ({none} utan)',
  'layers.ontimeNone': 'Ingen av de {n} klara uppgifterna hade förfallodag',
  'layers.ontimeNone.one': 'Den enda klara uppgiften hade ingen förfallodag',
  'layers.peopleHere': '{n} personer i den här enheten',
  'layers.peopleHere.one': '1 person i den här enheten',
  'layers.peopleAny': '{n} personer, från alla enheter',
  'layers.peopleAny.one': '1 person, från någon enhet',
  'layers.plannedTitle': 'Planerat härnäst',
  'layers.planned': 'Planerat',
  'layers.plan.timeline': 'Tidslinje med beroenden',
  'layers.plan.roadmap': 'Färdplan per kvartal',
  'layers.plan.workload': 'Arbetsbelastning mot kapacitet',
  'layers.plan.calibration': 'Kalibrering av uppskattningar',
  'layers.plan.learningFull': 'Hela vyn Lärande: trender och effekten av AI-hjälp',
  'rule.rollup': 'Räknat: varje öppen uppgift och varje uppgift som blev klar under den valda perioden, i de projekt som du ser. Gjort av personer här: en uppgift räknas när en person med sitt hemteam i enheten utför den; visas bara när minst 5 sådana personer gjorde det räknade arbetet, och döljs också när en mindre grupp skulle kunna räknas fram ur siffrorna bredvid. Arbete i projekt som ägs här: uppgifterna i de projekt som enheten eller en enhet under den äger. Försenad: öppen med en förfallodag före i dag. I tid som i ontime.v1. Klara per vecka: klara under perioden, delat med dess veckor.',
  'rule.funPublished': 'När ett kvartal eller ett år har tagit slut, eller en sprint är avslutad, räknas dess siffror fram en gång, för hela organisationen, och sparas: ett ändrat eller raderat svar, någon som slutar eller byter team, eller en uppgift som får en annan typ senare ändrar inget som visas. En grupp visas bara med minst 5 personer och 5 svar; en siffra som skulle låta en mindre grupp räknas fram döljs också. Ett år är summan av sina fyra kvartal och visas bara när vart och ett av dem visas; dess personer räknas per kvartal. Medelvärdet gäller de fem stegen.',
  'fun.yearPeople': 'Personer räknas per kvartal',
  'fun.unpublished': 'Inte publicerat: enheten fanns inte när periodens siffror publicerades.',
  'errors.LAYERS_ROLE': 'Nivåerna är för organisationens medlemmar.',
  'atWork.figures.title': 'Siffror om grupper',
  'atWork.figures.published': 'En grupps siffror för en period som har tagit slut räknas fram en gång och sparas. Om du senare ändrar ett svar, eller slutar, står den redan publicerade siffran kvar som den var. Om du raderar ett svar räknas varje publicerad siffra som räknade det fram igen utan det, och den gamla siffran dras tillbaka.',
  'atWork.figures.layers': 'Nivåerna summerar arbetet i ett team eller en division. Arbete som en enhets personer gjort visas bara för minst 5 personer; det finns ingen siffra för en enskild person.',
  'atWork.figures.limits': 'Det reglerna inte kan utesluta: siffror som skär genom flera grupperingar samtidigt (till exempel team, typer av arbete och sprintar tillsammans) är inte bevisat säkra mot varje subtraktion. Om alla i en grupp gav samma svar visar gruppens siffra det svaret.',
  // P4a-2
  'nav.heading': 'Riktning',
  'nav.dashboards': 'Översikter',
  'layers.toHeading': 'Riktning: mål och det arbete som inte hör till något mål',
  'layers.toDashboards': 'Översikter för varje nivå',
  'layers.plan.calendar': 'Kalender med förfallodagar, milstolpar och sprintar',
  'layers.plan.ics': 'Ett kalenderflöde (ICS) för dina egna uppgifter',
  'heading.title': 'Riktning: vart vi är på väg',
  'heading.intro': 'Målen för organisationen, dess divisioner och team för en period, hur långt de har kommit och arbetet som tjänar dem. Framstegen räknas fram ur nyckelresultaten; ingen modell bestämmer dem.',
  'heading.period': 'Tidsperiod',
  'heading.tree': 'Mål för {period}',
  'heading.goalsNone': 'Inga mål för {period} än.',
  'heading.lines': 'Två ärliga rader',
  'heading.drift': 'Arbete som inte är kopplat till något mål: {unlinked} av {done} uppgifter klara under {period} ({percent} %)',
  'heading.driftNone': 'Arbete som inte är kopplat till något mål: ingen uppgift blev klar under {period} i de projekt du ser.',
  'heading.noWork': 'Mål utan kopplat arbete: {without} av {of}',
  'heading.counted': 'Räknat: uppgifterna som blev klara under perioden, fram till i dag, i de projekt du ser; en uppgift räknas som kopplad när den, en uppgift ovanför den eller dess projekt är kopplad till ett mål som är aktivt eller klart (inte ett utkast, inte struket). Mål utan kopplat arbete: av de visade målen som inte är strukna, där även kopplat arbete i projekt du inte ser räknas.',
  'heading.newGoal': 'Nytt mål',
  'heading.toDashboards': 'Översikterna per nivå',
  'goal.status.draft': 'Utkast',
  'goal.status.active': 'Aktivt',
  'goal.status.done': 'Klart',
  'goal.status.dropped': 'Struket',
  'goal.statusLabel': 'Läge',
  'goal.owner': 'Ägare: {name}',
  'goal.ownerLabel': 'Ägare (valfritt)',
  'goal.noOwner': 'Ingen ägare angiven',
  'goal.noKr': 'Inga nyckelresultat än: inget framsteg visas.',
  'goal.noProgress': 'Inget framsteg än: inget av dess {of} nyckelresultat har ett värde.',
  'goal.progress': '{percent} % på väg, utifrån {from} av {of} nyckelresultat',
  'goal.keyResults': 'Nyckelresultat',
  'goal.work': 'Kopplat arbete som du ser: {open} öppna, {done} klara, {late} försenade.',
  'goal.noWork': 'Inget arbete kopplat än.',
  'goal.unseen': '{n} kopplade uppgifter till i projekt som du inte ser',
  'goal.unseen.one': '1 kopplad uppgift till i ett projekt som du inte ser',
  'goal.unseenCounts': '{open} öppna, {done} klara, {late} försenade (räknade, aldrig namngivna)',
  'goal.trend': 'Kopplade uppgifter klara per kvartal:',
  'goal.change': 'Ändra läget',
  'goal.save': 'Spara',
  'goal.saved': 'Sparat.',
  'goal.addKr': 'Lägg till ett nyckelresultat',
  'goal.krAdded': 'Nyckelresultatet är tillagt.',
  'goal.krTitle': 'Vad som mäts',
  'goal.krKind': 'Hur det mäts',
  'goal.krBaseline': 'Var det börjar (utgångsläge)',
  'goal.krTarget': 'Målvärde',
  'goal.krTargetItems': 'Valfritt: hur många kopplade uppgifter som ska bli klara. Lämnas det tomt räknas varje kopplad uppgift.',
  'goal.krUnit': 'Enhet (valfritt)',
  'goal.enter': 'Mata in ett värde',
  'goal.enterOne': 'Mata in',
  'goal.entered': 'Värdet är inmatat.',
  'goal.enterNote': 'Ett värde sparas med ditt namn och dagens datum; ett tidigare värde ändras aldrig.',
  'goal.link': 'Koppla arbete',
  'goal.linkProject': 'Ett projekt',
  'goal.linkProjectHint': 'Varje uppgift i projektet räknas. Ett projekt kopplas av sin projektledare.',
  'goal.linkItem': 'En uppgift, med sin kod',
  'goal.linkItemHint': 'Uppgiften och uppgifterna under den räknas. Kopplas av den som får ändra uppgiften.',
  'goal.linkOne': 'Koppla',
  'goal.linked': 'Kopplat.',
  'goal.choose': 'Välj',
  'goal.created': 'Målet är satt.',
  'goal.unit': 'Vems mål',
  'goal.parent': 'Tjänar målet (valfritt)',
  'goal.parentHint': 'Ett mål för samma enhet eller en enhet ovanför, vars period rymmer detta.',
  'goal.noParent': 'Inget: ett eget mål',
  'goal.title': 'Målet',
  'goal.titleHint': 'Alla medlemmar i organisationen läser målen och deras värden: nämn inte kunder eller ärenden, och mät inte en enskild person.',
  'atWork.goals.title': 'Mål',
  'atWork.goals.who': 'Alla medlemmar i organisationen läser målen, vem som äger vart och ett och vem som matade in varje värde för ett nyckelresultat, med dagen. Arbetet som är kopplat till ett mål räknas ur de uppgifter varje läsare får se; arbete i projekt du inte ser räknas bara som ett antal.',
  'atWork.goals.noScore': 'Ett måls framsteg handlar om arbetet, inte om ett betyg på dess ägare eller på någon som gjorde arbetet. Ett mål sätts aldrig för att mäta en enskild person; det finns ingen vy av mål per person, utom din egen översikt.',
  'goal.why': 'Varför (valfritt)',
  'goal.whoSets': 'En enhets mål sätts av dess chefer, cheferna ovanför och administratörer.',
  'kr.kind.items_done': 'klara uppgifter',
  'kr.kind.metric': 'ett tal',
  'kr.kind.milestone': 'en milstolpe',
  'kr.items': '{current} av {of} kopplade uppgifter klara',
  'kr.noItems': 'Inga kopplade uppgifter än',
  'kr.metric': 'Nu {current} {unit} (från {baseline}, målvärde {target})',
  'kr.metricRange': 'från {baseline}, målvärde {target} {unit}',
  'kr.noValue': 'Inget värde inmatat än',
  'kr.reached': 'Nådd',
  'kr.notReached': 'Inte nådd än',
  'kr.lastEntry': 'Senaste värde {value}, för {date}, inmatat av {name}',
  'rule.kr': 'Klara uppgifter: de kopplade uppgifter som är klara (när de än blev klara), av målvärdet när ett är satt, annars av varje kopplad uppgift som inte är avbruten (även de i projekt du inte ser, som antal); högst 100 %. Ett tal: hur långt det senaste värdet har kommit från utgångsläget mot målvärdet; det senaste värdet är det för den senaste dagen. En milstolpe: 100 % när den är nådd, annars 0 %. Ett mål: medelvärdet av de nyckelresultat som har ett värde; ett nyckelresultat utan värde lämnas utanför och räknas för sig. En uppgift är kopplad när den, en uppgift ovanför den eller dess projekt är kopplad till målet, eller till ett aktivt eller klart mål under det.',
  'rule.drift': 'De uppgifter som blev klara under perioden fram till i dag, i de projekt du ser, och bland dem de som inget mål med läget aktivt eller klart är kopplat till, direkt, via en uppgift ovanför eller via projektet. Öppna och avbrutna uppgifter, och uppgifter klara utanför perioden, räknas inte. Är inget klart finns ingen andel.',
  'dash.title': 'Översikter',
  'dash.titleOf': 'Översikt: {name} · {kind}',
  'dash.titleProject': 'Översikt: {key} · {name}',
  'dash.title.organisation': 'Hela organisationen',
  'dash.title.you': 'Din översikt',
  'dash.intro': 'Fasta delar för en nivå: arbetet längs båda vägarna, målen och driften för detta kvartal och glädjesiffrorna för det senast avslutade kvartalet. Varje siffra säger vad den räknade.',
  'dash.introProject': 'Projektets arbete, dess mål och drift för detta kvartal och glädjesiffrorna för dess senast stängda sprint.',
  'dash.choose': 'Välj en översikt',
  'dash.guest': 'Som gäst har du din egen översikt; nivåerna och deras mål är för organisationens medlemmar.',
  'dash.work': 'Arbetet',
  'dash.heading': 'Riktning för {period}',
  'dash.toHeading': 'Öppna vyn Riktning',
  'dash.fun': 'Glädje efter arbetet, {quarter}',
  'dash.funTitle': 'Glädje efter arbetet',
  'dash.funSprint': 'Glädje efter arbetet, {sprint}',
  'dash.funNote': 'Siffrorna för en avslutad period, som de publicerades; en grupp med färre än {min} personer visar ingen siffra.',
  'dash.noSprint': 'Ingen stängd sprint än: inget att visa.',
  'dash.children': 'Enheterna under',
  'dash.toLayers': 'Jämför dem sida vid sida under Nivåer',
  'dash.ownedBy': 'Ägs av {name}',
  'dash.countedProject': 'Räknat: varje öppen uppgift och varje uppgift klar från {from} till {to}, i detta projekt.',
  'dash.onlyYou': 'Bara du ser det här.',
  'dash.yourWork': 'Ditt arbete',
  'dash.toMyWork': 'Mitt arbete',
  'dash.fig.dueSoon': 'Förfaller snart',
  'dash.dueSoon': '{n} uppgifter förfaller inom 7 dagar',
  'dash.dueSoon.one': '1 uppgift förfaller inom 7 dagar',
  'dash.fig.done': 'Klart av dig under perioden',
  'dash.yourWorkNote': 'Uppgifterna du utför eller äger, i de projekt du ser; klara och i tid: uppgifterna du utförde, klara från {from} till {to}.',
  'dash.yourGoals': 'Målen du äger',
  'dash.noOwnGoals': 'Du äger inget mål för detta kvartal.',
  'errors.GOAL_LEAD_ONLY': 'En enhets mål sätts av dess chefer, cheferna ovanför och administratörer.',
  'errors.GOAL_PARENT_UNIT': 'Ett mål kan bara tjäna ett mål för sin egen enhet eller en enhet ovanför.',
  'errors.GOAL_PARENT_PERIOD': 'Ett måls period måste ligga inom perioden för målet det tjänar.',
  'errors.GOAL_DROPPED': 'Målet är struket: det tar inget nytt nyckelresultat, ingen ny koppling och inget nytt mål under sig.',
  'errors.GOAL_FIXED': 'Ett måls enhet, målet det tjänar och dess period, och ett nyckelresultats slag, bestäms när de skapas.',
  'errors.GOAL_LINK_EXISTS': 'Detta är redan kopplat till målet.',
  'errors.HEADING_ROLE': 'Målen är för organisationens medlemmar.',
  'errors.KR_SHAPE': 'Ett tal behöver ett utgångsläge och ett annat målvärde; klara uppgifter tar ett helt målvärde eller inget; en milstolpe tar inget av dem.',
  'errors.KR_ENTRY_KIND': 'Ett värde matas in för ett tal, eller nådd / inte nådd för en milstolpe; klara uppgifter räknas fram ur de kopplade uppgifterna.',
  'errors.KR_ENTRY_FUTURE': 'Ett värde matas in för i dag eller en dag före.',

  'nav.plans': 'Planering',
  'plans.title': 'Planering: tidslinjen, färdplanen, arbetsbelastningen och kalendern',
  'plans.intro': 'Vyer över det arbete du ser, bara för läsning. Varje siffra säger vad den räknade.',
  'plans.choose': 'Välj en vy',
  'plans.timeline': 'Tidslinje',
  'plans.roadmap': 'Färdplan',
  'plans.workload': 'Arbetsbelastning',
  'plans.calendar': 'Kalender',
  'plans.timelineAbout': 'Ett projekts uppgifter från start till förfallodag, vad som blockerar vad, milstolparna och i dag.',
  'plans.roadmapAbout': 'Projekt och epiker per kvartal, per ägande enhet, med de mål de tjänar.',
  'plans.workloadAbout': 'Dina planerade timmar per vecka mot din kapacitet; för chefer deras personer och teamens summor.',
  'plans.calendarAbout': 'Förfallodagar, milstolpar och sprintdagar per månad, och ett kalenderflöde till din egen kalenderapp.',
  'layers.builtTitle': 'Byggt sedan dess: planeringsvyerna, kalibreringen och hela vyn Lärande',
  'timeline.intro': 'Staplarna går från start till förfallodag; en ring är en förfallodag utan start; en romb är en milstolpe.',
  'timeline.readOnly': 'Bara läsning: ändra datum på själva kortet.',
  'timeline.project': 'Projekt',
  'timeline.noProjects': 'Du ser inga projekts uppgifter än.',
  'timeline.nothing': 'Ingen uppgift i projektet har en förfallodag, så inget ritas.',
  'timeline.chartTitle': 'Tidslinje för {project}',
  'timeline.today': 'I dag',
  'timeline.late': 'Försenad',
  'timeline.blocked': 'Blockerad',
  'timeline.reversed': 'Starten ligger efter förfallodagen',
  'timeline.legend.bar': 'Från start till förfallodag',
  'timeline.legend.mark': 'Bara förfallodag',
  'timeline.legend.milestone': 'Milstolpe',
  'timeline.legend.blocks': 'Blockerar',
  'timeline.kind.bar': 'Från start till förfallodag',
  'timeline.kind.mark': 'Förfallodag',
  'timeline.kind.milestone': 'Milstolpe',
  'timeline.col.item': 'Uppgift',
  'timeline.col.kind': 'Ritas som',
  'timeline.col.start': 'Startdag',
  'timeline.col.due': 'Förfaller',
  'timeline.col.state': 'Läge',
  'timeline.barWords': '{item}: från {from} till {to}',
  'timeline.markWords': '{item}: förfaller {day}',
  'timeline.blocksWords': '{a} blockerar {b}',
  'timeline.notDrawn': '{a} blockerar {b}, som inte ritas (ingen förfallodag)',
  'timeline.undated': '{n} uppgifter saknar datum och ritas inte',
  'timeline.undated.one': '1 uppgift saknar datum och ritas inte',
  'timeline.outside': '{n} kopplingar leder till uppgifter i andra projekt och ritas inte',
  'timeline.outside.one': '1 koppling leder till en uppgift i ett annat projekt och ritas inte',
  'roadmap.intro': 'Projekten spänner över kvartalen från start till målet; epikerna från start till förfallodag. Grupperade efter den enhet som äger dem.',
  'roadmap.prev': 'Året före',
  'roadmap.next': 'Året efter',
  'roadmap.chartTitle': 'Färdplan {year}',
  'roadmap.nothing': 'Inget projekt du ser har datum i det här året.',
  'roadmap.now': 'nu',
  'roadmap.openEnded': 'inget mål än',
  'roadmap.fromItems': 'från dess uppgifter',
  'roadmap.noDates': 'Inga datum',
  'roadmap.done': 'klar',
  'roadmap.restricted': 'begränsat',
  'roadmap.col.work': 'Projekt eller epik',
  'roadmap.col.quarters': 'Kvartal',
  'roadmap.col.dates': 'Datum',
  'roadmap.col.goals': 'Mål det tjänar',
  'roadmap.undated': '{n} projekt saknar datum och listas utan kvartal',
  'roadmap.undated.one': '1 projekt saknar datum och listas utan kvartal',
  'roadmap.noGoalsGuest': 'Målen är för organisationens medlemmar, så inget visas här.',
  'workload.intro': 'Planerade timmar per vecka: uppskattningarna för de öppna uppgifter en person utför, fördelade över arbetsdagarna fram till förfallodagen, mot personens kapacitet.',
  'workload.onlyLeads': 'Planerade timmar per person ser bara personen och cheferna för personens enheter. Aldrig utfall, aldrig glädje, aldrig i tid.',
  'workload.weeks': 'Veckor som visas',
  'workload.weeksN': '{n} veckor',
  'workload.weeksN.one': '1 vecka',
  'workload.key': 'Hur full en vecka är',
  'workload.band.0': 'Inget planerat',
  'workload.band.1': 'Under hälften',
  'workload.band.2': 'Hälften till det mesta',
  'workload.band.3': 'Nästan eller precis full',
  'workload.band.4': 'Över kapaciteten',
  'workload.over': 'Över',
  'workload.cell': '{planned} / {capacity} tim',
  'workload.cellWords': 'Veckan som börjar {week}: {planned} timmar planerade av {capacity}',
  'workload.cellsLabel': 'Planerade timmar per vecka för {name}; siffrorna finns i tabellen nedanför.',
  'workload.thisWeek': 'Den här veckan',
  'workload.you': 'Du',
  'workload.unitTitle': 'Personer och summor för {name}',
  'workload.noPeople': 'Här finns ingen annan vars planerade belastning du får se. Chefer ser sina personer.',
  'workload.totals': 'Summor per enhet',
  'workload.people': '{n} personer',
  'workload.people.one': '1 person',
  'workload.small': 'Färre än {min} personer: ingen summa visas.',
  'workload.protect': 'Visas inte, så att en mindre grupp bredvid inte kan räknas fram.',
  'workload.later': 'Planerat efter de veckor som visas: {hours} tim',
  'workload.unscheduled': 'Inte schemalagt (ingen förfallodag): {hours} tim i {items} uppgifter',
  'workload.noEstimate': '{n} uppgifter saknar uppskattning i timmar',
  'workload.noEstimate.one': '1 uppgift saknar uppskattning i timmar',
  'workload.lateCount': '{n} uppgifter är försenade: deras timmar ligger i den här veckan',
  'workload.lateCount.one': '1 uppgift är försenad: dess timmar ligger i den här veckan',
  'workload.unseen': '{n} uppgifter i projekt du inte ser: {hours} tim, räknade utan namn',
  'workload.unseen.one': '1 uppgift i ett projekt du inte ser: {hours} tim, räknad utan namn',
  'workload.defaultCapacity': 'Där ingen kapacitet är satt räknas 32 timmar i veckan (en 40-timmarsvecka minus möten).',
  'workload.whatCounts': 'Vad timmarna består av',
  'workload.noItems': 'Ingen öppen uppgift som du ser.',
  'workload.noHours': 'ingen uppskattning i timmar',
  'workload.hours': '{hours} tim',
  'workload.setCapacity': 'Sätt kapaciteten',
  'workload.capacity': 'Kapacitet (timmar per vecka)',
  'workload.capacityNote': 'Timmar som finns för planerat arbete. Skriv inget skäl: Pascal sparar inte varför.',
  'workload.from': 'Från',
  'workload.to': 'Till',
  'workload.capacitySaved': 'Kapaciteten är sparad.',
  'workload.col.week': 'Veckan som börjar',
  'workload.col.planned': 'Planerade timmar',
  'workload.col.capacity': 'Kapacitet',
  'workload.col.state': 'Hur full',
  'capacity.range': 'Från {min} till {max} timmar.',
  'calendar.intro': 'Förfallodagar för öppna uppgifter, milstolpar och sprintarnas första och sista dag.',
  'calendar.scope': 'Vems arbete',
  'calendar.mine': 'Mina',
  'calendar.all': 'Allt jag ser',
  'calendar.prev': 'Månaden före',
  'calendar.next': 'Månaden efter',
  'calendar.list': 'Allt den här månaden',
  'calendar.none': 'Inget förfaller den här månaden i det som visas.',
  'calendar.more': '{n} till',
  'calendar.more.one': '1 till',
  'calendar.kind.due': 'Förfaller',
  'calendar.kind.milestone': 'Milstolpe',
  'calendar.kind.sprintStart': 'Sprinten börjar',
  'calendar.kind.sprintEnd': 'Sprinten slutar',
  'calendar.short.due': 'Förfaller',
  'calendar.short.milestone': 'Milstolpe',
  'calendar.short.sprintStart': 'Börjar',
  'calendar.short.sprintEnd': 'Slutar',
  'calendar.yearWheel': 'Årshjulet kommer med de återkommande uppgifterna (planerat).',
  'ics.title': 'Kalenderflöde (ICS)',
  'ics.intro': 'Dina egna förfallodagar, milstolpar och sprintdagar i din kalenderapp, bara för läsning. Bara dina: ingen kan göra ett åt dig.',
  'ics.privacy': 'Din kalenderapp, eller företaget bakom den, hämtar den här adressen. Välj bara koder för att hålla rubrikerna utanför. Begränsat arbete visar aldrig sin kod eller rubrik.',
  'ics.none': 'Du har inget kalenderflöde.',
  'ics.live': 'Du har ett flöde sedan {day}: {detail}.',
  'ics.detail': 'Vad händelserna säger',
  'ics.detail.codes': 'Bara uppgiftskoder',
  'ics.detail.titles': 'Koder och rubriker',
  'ics.make': 'Gör ett flöde',
  'ics.replace': 'Gör ett nytt flöde (den gamla adressen slutar fungera)',
  'ics.revoke': 'Återkalla flödet',
  'ics.revoked': 'Flödet är återkallat: adressen fungerar inte längre.',
  'ics.once': 'Adressen visas en gång. Den som har den kan läsa ditt flöde: använd den bara i din egen kalenderapp.',
  'ics.address': 'Flödets adress',
  'rule.load': 'Planerade timmar: den aktuella uppskattningen i timmar för varje öppen uppgift (backlogg, redo, pågår, granskning) som en person utför, delad mellan dem som utför den, jämnt fördelad över arbetsdagarna från start (eller i dag) till förfallodagen. En försenad uppgift räknas i den här veckan; en utan förfallodag är inte schemalagd; en utan uppskattning räknas för sig. Kapacitet: den senast satta kapaciteten för veckan, annars 32 timmar. Aldrig utfall, glädje eller i tid.',
  'errors.CAPACITY_LEAD_ONLY': 'En persons kapacitet sätts av personen själv eller cheferna för personens enheter.',
  'errors.CAPACITY_DAYS': 'En kapacitet slutar samma dag som den börjar eller senare.',
  'errors.FEED_REVOKED': 'Det här kalenderflödet är återkallat.',
  'errors.ITEM_DATES': 'Starten ligger på eller före förfallodagen.',
  'errors.PROJECT_DATES': 'Ett projekts mål ligger på eller efter dess start.',
  'item.startOn': 'Startdag',
  'item.startHint': 'För tidslinjen: dagen arbetet är tänkt att börja.',
  'errors.LOAD_ROLE': 'Teamens summor är för organisationens medlemmar, från gruppstorleken eller för teamets chefer.',
  // P4c: kalibrering och hela vyn Lärande
  'learning.unitTitle': 'Kalibrering och trender per enhet',
  'layers.plannedNone': 'Inget av P4 är planerat längre: alla delar är byggda.',
  'calib.title': 'Kalibrering av uppskattningar',
  'calib.yoursTitle': 'Dina uppskattningar',
  'calib.onlyYou': 'Bara du ser det här. Ingen annan kan det: varken din chef eller en administratör.',
  'calib.window': 'Uppgifter klara från {from} till {to}, med en uppskattning i timmar som frystes när arbetet började och ett ungefärligt utfall.',
  'calib.notEnough': 'För lite underlag än: {n} av {min} uppgifter',
  'calib.notEnough.one': 'För lite underlag än: {n} av {min} uppgifter',
  'calib.counted': 'Kalibrering: {n} uppgifter med både uppskattning och utfall',
  'calib.counted.one': 'Kalibrering: 1 uppgift med både uppskattning och utfall',
  'calib.withoutBoth': '{n} klara uppgifter saknade uppskattning i timmar eller utfall',
  'calib.withoutBoth.one': '1 klar uppgift saknade uppskattning i timmar eller utfall',
  'calib.factor': 'Uppgifterna tog {factor} × uppskattningen',
  'calib.suggest': 'Förslag: multiplicera en uppskattning med {factor}. Den ursprungliga uppskattningen står kvar; du bestämmer.',
  'calib.declined': 'Dina uppskattningar är lika bra som någon korrigering vi kan räkna fram.',
  'calib.declinedUnit': 'Uppskattningarna här är lika bra som någon korrigering vi kan räkna fram.',
  'calib.gainBetter': 'Prövat på de {n} senaste uppgifterna: korrigeringen hade fört uppskattningarna {gain} % närmare vad arbetet tog. Ett förslag kräver minst {min} %.',
  'calib.gainBetter.one': 'Prövat på den senaste uppgiften: korrigeringen hade fört uppskattningen {gain} % närmare vad arbetet tog. Ett förslag kräver minst {min} %.',
  'calib.gainWorse': 'Prövat på de {n} senaste uppgifterna: korrigeringen hade gjort uppskattningarna {gain} % sämre.',
  'calib.gainWorse.one': 'Prövat på den senaste uppgiften: korrigeringen hade gjort uppskattningen {gain} % sämre.',
  'calib.exact': 'De senaste uppskattningarna var exakta: det finns inget att korrigera.',
  'calib.measured': 'Uppmätt: {measured} ×',
  'calib.towards': 'Dragen mot {unit}',
  'calib.towardsNone': 'Dragen mot ingen korrigering: ingen bredare siffra visas',
  'calib.unitsTitle': 'Kalibrering per enhet',
  'calib.unitsIntro': 'Uppgifterna som utförts av personer vars hemteam finns i enheten, i projekten du ser. En enhet visas bara när minst {min} personer gjorde det räknade arbetet, så att ingens egen kalibrering kan läsas ut.',
  'calib.chartTitle': 'Hur lång tid arbetet tog mot uppskattningen: {unit} och enheterna under den',
  'calib.noteSuggest': 'en korrigering föreslås',
  'calib.noteDeclined': 'ingen korrigering föreslås',
  'calib.people': '{n} personer gjorde det räknade arbetet',
  'calib.people.one': '1 person gjorde det räknade arbetet',
  'chart.scope': 'Enhet',
  'chart.factor': 'Faktor',
  'chart.note': 'Kommentar',
  'chart.notShown': 'visas inte',
  'chart.quarter': 'Kvartal',
  'chart.axis': 'Axel',
  'chart.row': 'Typ',
  'trends.title': 'Trender: de senaste fyra kvartalen',
  'trends.toDate': '{quarter} (hittills)',
  'trends.intro': 'Arbetet i projekten som enheten eller en enhet under den äger, som du ser, under de senaste fyra kvartalen (det här hittills).',
  'patterns.title': 'Mönster i problemen',
  'patterns.none': 'Inget problem registrerades under de här kvartalen i projekten du ser.',
  'patterns.chartTitle': '{n} problem registrerade, per kvartal',
  'patterns.chartTitle.one': '1 problem registrerat, per kvartal',
  'patterns.problems': 'Antal problem',
  'patterns.recurring': 'Återkommande orsaker: {list}',
  'patterns.noneRecurring': 'Ingen orsak kom tillbaka mer än en gång.',
  'patterns.total': 'Totalt',
  'patterns.notSaid': 'inte angivet {n}',
  'patterns.notSaid.one': 'inte angivet 1',
  'patterns.lessons': 'Vad vi gör nästa gång, per slags problem',
  'difficulty.title': 'Svårighet',
  'difficulty.chartTitle': 'Svårighetsradarn för klara uppgifter, per kvartal (0 ingen till 4 extrem)',
  'difficulty.notShown': 'för lite underlag',
  'difficulty.rated': '{n} bedömda uppgifter',
  'difficulty.rated.one': '1 bedömd uppgift',
  'difficulty.notEnough': 'För lite underlag: {n} av {min} bedömda uppgifter',
  'difficulty.notEnough.one': 'För lite underlag: {n} av {min} bedömda uppgifter',
  'difficulty.type': 'Uppgiftstyp',
  'difficulty.gapNotEnough': 'Före och efter: för lite underlag ({n} av {min} uppgifter bedömda båda gångerna).',
  'difficulty.gapNotEnough.one': 'Före och efter: för lite underlag ({n} av {min} uppgifter bedömda båda gångerna).',
  'difficulty.gapNone': 'Före och efter stämmer på varje axel ({n} uppgifter bedömda båda gångerna).',
  'difficulty.gapNone.one': 'Före och efter stämmer på varje axel (1 uppgift bedömd båda gångerna).',
  'difficulty.gapUp': '{axis}: {gap} högre efter arbetet än före, i genomsnitt ({n} uppgifter)',
  'difficulty.gapUp.one': '{axis}: {gap} högre efter arbetet än före (1 uppgift)',
  'difficulty.gapDown': '{axis}: {gap} lägre efter arbetet än före, i genomsnitt ({n} uppgifter)',
  'difficulty.gapDown.one': '{axis}: {gap} lägre efter arbetet än före (1 uppgift)',
  'funTrend.title': 'Hur arbetet kändes, per kvartal',
  'funTrend.intro': 'Bara kvartal som har tagit slut, och bara grupper med minst {min} personer; siffrorna publiceras en gång och står kvar.',
  'funTrend.chartTitle': 'Medelsvaret före och efter, för hela enheten (1 dränerande till 5 energigivande)',
  'funTrend.noGap': 'ingen skillnad att visa',
  'aieffect.title': 'Effekten av AI-hjälp',
  'aieffect.notCause': 'Jämförelse, inte orsak: uppgifterna valdes inte slumpmässigt för AI-hjälp.',
  'aieffect.none': 'Ingen uppgift blev klar under de här kvartalen i projekten du ser.',
  'aieffect.chartTitle': 'Ledtid i arbete, medianen i dagar, med och utan AI-hjälp',
  'aieffect.with': 'Med AI-hjälp',
  'aieffect.without': 'Utan AI-hjälp',
  'aieffect.days': 'dagar',
  'aieffect.side': 'Hjälp',
  'aieffect.n': 'Uppgifter',
  'aieffect.items': '{n} uppgifter',
  'aieffect.items.one': '1 uppgift',
  'aieffect.notEnough': 'För lite underlag för att jämföra (minst {min} uppgifter var)',
  'aieffect.noCycle': 'historiken säger inget',
  'aieffect.cycle': '{days} dagar (median av {n})',
  'aieffect.cycle.one': '{days} dagar (1 uppgift)',
  'aieffect.kOfN': '{k} av {n}',
  'aieffect.kOfN.one': '{k} av 1',
  'aieffect.noDue': 'ingen hade ett förfallodatum',
  'aieffect.cycleHead': 'Ledtid i arbete',
  'aieffect.ftrHead': 'Rätt första gången',
  'aieffect.ontimeHead': 'I tid',
  'aieffect.achievedHead': 'Uppnått',
  'aieffect.expertsTitle': 'Per AI-expert: hur hjälpen användes',
  'aieffect.expert': 'AI-expert',
  'aieffect.wrongHead': 'Problem: fel i AI-svaret',
  'rule.calib': 'Uppgifterna som blev klara de senaste 12 månaderna med en uppskattning i timmar, frusen när arbetet började, och ett ungefärligt utfall. För var och en: utfallet delat med uppskattningen; faktorn är deras geometriska medelvärde, dragen mot den bredare siffran ovanför (ditt team, divisionen, organisationen) med vikten n / (n + 10), eller mot ingen korrigering när ingen visas. Färre än 8 uppgifter: ingen faktor alls. Provet: de senaste 30 % av uppgifterna hålls utanför, faktorn räknas om på de äldre och prövas på dem; den föreslås bara när den för det typiska felet (medianen) minst 10 % närmare. Den ursprungliga uppskattningen står alltid kvar. För en enhet: uppgifterna som dess personer utförde, visas bara med minst 5 personer.',
  'rule.patterns': 'Problemen som hittades under de fyra kvartalen (efter dagen de hittades), i projekten som enheten eller en enhet under den äger och som du ser, räknade per kvartal och slag. Förlorad tid räknas som den angavs, i sina intervall, aldrig omräknad till timmar. En återkommande orsak är ett slag med minst två problem; de tre med flest nämns. Lärdomarna är texterna om nästa gång, de senaste först.',
  'rule.difficulty': 'För varje klar uppgift: radarn efter när den finns, annars radarn före; medelvärdet per axel över uppgifterna som bedömde den, per kvartal och per typ. Ett kvartal eller en typ med färre än 3 bedömda uppgifter visar inget medelvärde: ett medelvärde av en eller två uppgifter är den uppgiften. Skillnaden är efter minus före, över uppgifterna som bedömdes båda gångerna, från 3 stycken.',
  'rule.aieffect': 'Uppgifterna som blev klara under de fyra kvartalen, per typ, i två grupper: med AI-hjälp (en AI-expert bland utförarna, eller ett registrerat AI-bidrag) och utan. För varje: medianen av ledtiden i arbete (cycle.v1), rätt första gången (rework.v1), i tid bland dem med ett förfallodatum vid start (ontime.v1) och uppnått resultat. En grupp med färre än 5 uppgifter visar ingen siffra. Det är en jämförelse, inte en orsak: ingen valde slumpmässigt vilka uppgifter som fick AI-hjälp.',
  // ── P5: familjelänkar (filer som en person bär mellan familjens produkter) ───────────────────────────────────
  'nav.family': 'Familjen',
  'family.title': 'Familjelänkar',
  'family.intro': 'Arbete som familjen föreslår kommer som en fil som en person tar in. Inget kommer in av sig självt, och inget blir ett kort förrän en person godkänner det.',
  'family.dataNote': 'Importerad text är data: Pascal visar den och följer den aldrig som en instruktion.',
  'family.project': 'Projekt',
  'family.chooseProject': 'Välj ett projekt',
  'family.noProjects': 'Du ser inget projekt än. En familjefil tas in i ett projekt som du arbetar i.',
  'family.importTitle': 'Ta in en fil',
  'family.file': 'Filen: pascal.workitem.v1 från ett syskon, eller Horizons utbytesfil',
  'family.horizonHint': 'Från Horizon: hämta utbytesfilen för Pascal (kontrakt 2) medan du är inloggad i Horizon och välj den här. Pascal läser bara Horizons offentliga förändringar.',
  'family.filterInstruments': 'Bara dessa regelverk (Horizonfil, valfritt)',
  'family.filterJurisdictions': 'Bara dessa jurisdiktioner (Horizonfil, valfritt)',
  'family.filterHint': 'Koder åtskilda med kommatecken, till exempel AMLR, DORA.',
  'family.import': 'Importera',
  'family.importing': 'Läser filen…',
  'family.cannotImport': 'Du kan läsa projektets inkorg; en ledare eller medlem i projektet tar in filer och beslutar.',
  'family.report.title': 'Vad filen innehöll',
  'family.report.file': 'Från {product} ({instance}). Filens SHA-256: {sha}',
  'family.report.seen': '{n} poster i filen',
  'family.report.seen.one': '1 post i filen',
  'family.report.proposed': '{n} nya förslag',
  'family.report.proposed.one': '1 nytt förslag',
  'family.report.updates': '{n} uppdateringar av kort',
  'family.report.updates.one': '1 uppdatering av ett kort',
  'family.report.already': '{n} importerade tidigare, oförändrade',
  'family.report.already.one': '1 importerad tidigare, oförändrad',
  'family.report.superseded': '{n} äldre förslag ersatta',
  'family.report.superseded.one': '1 äldre förslag ersatt',
  'family.report.stale': '{n} äldre än versionen som Pascal har',
  'family.report.stale.one': '1 äldre än versionen som Pascal har',
  'family.report.otherProject': '{n} hör till ett annat projekt',
  'family.report.otherProject.one': '1 hör till ett annat projekt',
  'family.report.skipped': '{n} hoppades över',
  'family.report.skipped.one': '1 hoppades över',
  'family.skip.malformed': 'inte som kontraktet säger',
  'family.skip.checksum_mismatch': 'kontrollsumman stämmer inte med innehållet',
  'family.skip.duplicate_in_file': 'samma referens två gånger i filen',
  'family.skip.filtered': 'utanför filtret',
  'family.skip.over_cap': 'över 500 i en import',
  'family.lane.title': 'Inkorg',
  'family.lane.empty': 'Inga förslag väntar här.',
  'family.lane.count': '{n} förslag väntar på beslut',
  'family.lane.count.one': '1 förslag väntar på beslut',
  'family.from': 'Från {product}, {ref}, version {revision}',
  'family.importedBy': 'Importerad av {name} den {day}',
  'family.exportedBy': 'Exporterad av {name}, som källan anger',
  'family.update': 'Uppdatering av {code}',
  'family.newCard': 'Ett nytt kort',
  'family.field.title': 'Rubrik',
  'family.field.summary': 'Beskrivning',
  'family.field.due_on': 'Förfaller',
  'family.field.due_kind': 'Slag av förfallodatum',
  'family.changeLine': '{field}: {before} → {after}',
  'family.none': '(inget)',
  'family.proposal.kind': 'Typ: {kind}',
  'family.proposal.due': 'Förfaller {day}',
  'family.proposal.noDue': 'Inget förfallodatum',
  'family.proposal.fourEyes': 'Fyra ögon',
  'family.accept': 'Godkänn som kort',
  'family.acceptUpdate': 'Godkänn uppdateringen',
  'family.accepted': 'Godkänd som {code}',
  'family.reject': 'Avvisa',
  'family.rejectReason': 'Varför inte?',
  'family.rejectConfirm': 'Avvisa förslaget',
  'family.closedBy.source': 'Stängs i {product}: Pascal skickar tillbaka sin status, och en person där beslutar.',
  'family.closedBy.pascal': 'Stängs i Pascal.',
  'family.decided.title': 'Senast beslutade',
  'family.state.accepted': 'Godkänd',
  'family.state.rejected': 'Avvisad',
  'family.state.superseded': 'Ersatt av en nyare version',
  'family.decidedBy': '{state} av {name}',
  'family.status.title': 'Status tillbaka till en produkt',
  'family.status.intro': 'En pascal.status.v1-fil med projektets kort som kom från en produkt. Den stänger aldrig något där: en person i den produkten beslutar.',
  'family.status.product': 'Produkt',
  'family.status.export': 'Skriv statusfilen',
  'family.status.download': 'Ladda ner {file}',
  'family.status.written': '{n} kort i filen',
  'family.status.written.one': '1 kort i filen',
  'family.origin.title': 'Ursprung',
  'family.origin.line': 'Från {product}, {ref}, version {revision}, importerad av {name}',
  'family.origin.accepted': 'Godkänd av {name}',
  'family.origin.open': 'Öppna i {product}',
  'errors.FILE_NOT_JSON': 'Filen är inte JSON. Välj filen som den andra produkten exporterade.',
  'errors.FILE_UNKNOWN_SCHEMA': 'Pascal läser pascal.workitem.v1 och Horizons utbytesfil (kontrakt 2); den här filen är ingen av dem.',
  'errors.FILE_SHAPE': 'Filen är inte som dess kontrakt säger. Inget importerades.',
  'errors.FILE_HASH_MISMATCH': 'Filens kontrollsumma stämmer inte med innehållet: den har ändrats efter exporten. Inget importerades.',
  'errors.FILE_TOO_MANY_ITEMS': 'En fil rymmer högst {max} poster. Be om mindre filer.',
  'errors.FILE_TOO_LARGE': 'Filen är större än {max} MB.',
  'errors.FILE_NOT_PUBLIC': 'Pascal importerar bara Horizons offentliga flöde; den här filen har en annan klass.',
  'errors.ENVELOPE_CONFLICT': '{ref} har ändrats i en version som Pascal redan har, så filen avvisas. Be om en fil med en ny version.',
  'errors.ENVELOPE_DECIDED': 'Det här förslaget är redan beslutat.',
  'errors.STATUS_NO_ITEMS': 'Inget kort i det här projektet kom från den produkten.',
  // ── P6: AI experts, Ask Pascal, How Pascal works ───────────────────────────────────────────────────────────
  'nav.ask': 'Fråga Pascal',
  'nav.how': 'Så fungerar Pascal',
  'nav.ai': 'AI-inställningar',
  'ai.refusal.unknown_model': 'Modellen är inte en som Pascal får anropa.',
  'ai.refusal.engine_not_for_class': 'Organisationens text går bara till Claude via Anthropics API; den här modellen är inte tillåten för den.',
  'ai.refusal.ai_not_allowed': 'AI är avstängd för den här organisationen. En administratör slår på den under AI-inställningar, efter att ha registrerat att organisationen godtar behandling hos Anthropic.',
  'ai.refusal.no_engine_for_class': 'Ingen AI-motor för den här sortens uppgifter är inställd på servern. Fråga den som driver den.',
  'ai.refusal.boundary_unchecked': 'Pascal kunde inte kontrollera organisationens AI-tillåtelse precis före sändningen, så ingenting skickades.',
  'ai.off.allowance': 'AI är avstängd för organisationen tills en administratör slår på den.',
  'ai.off.engine': 'Ingen AI-motor är inställd på servern, så AI kan inte köras här.',
  'ai.preview.title': 'Innan något skickas',
  'ai.preview.intro': 'Detta är vad som skulle gå till modellen. Ingenting skickas förrän du trycker Skicka. Svaret kommer tillbaka som ett förslag: ingenting på tavlan ändras förrän en person godtar det.',
  'ai.preview.model': 'Modell',
  'ai.preview.engine': 'Motor',
  'ai.preview.class': 'Dataklass',
  'ai.preview.worstCase': 'Högsta möjliga kostnad',
  'ai.preview.wouldRefuse': 'Detta skulle avvisas: {reason}',
  'ai.preview.prompt': 'Prompten, som den skulle skickas',
  'ai.preview.send': 'Skicka',
  'ai.engine.anthropic': 'Anthropics API (Claude)',
  'ai.engine.openrouter': 'OpenRouter, låst till Inceptron (EU, ingen lagring)',
  'ai.class.client': 'Klient: organisationens egen text',
  'ai.class.synthetic': 'Syntetisk: en deklarerat påhittad organisation',
  'ai.class.public': 'Offentlig: text som följer med Pascal',
  'ai.whatWentIn.open': 'Detta skickades till modellen',
  'ai.call.status': 'Utfall',
  'ai.call.status.ok': 'Besvarat',
  'ai.call.status.error': 'Misslyckades',
  'ai.call.status.refused': 'Avvisat före sändning: ingenting lämnade Pascal',
  'ai.call.status.cancelled': 'Avbrutet',
  'ai.call.why': 'Varför',
  'ai.call.nothingSent': 'Ingen: ingenting skickades',
  'ai.call.cost': 'Kostnad',
  'ai.call.when': 'När',
  'ai.call.partsIntro': 'Varje del, i den ordning den sattes ihop. Pascals egna mallar visas som text; organisationens text sparas bara som ett fingeravtryck av det som visades, med var den finns.',
  'ai.part.date_block': 'Datumet',
  'ai.part.fence_rules': 'Hur det givna ska läsas',
  'ai.part.preamble': 'Uppgiftens inledning',
  'ai.part.instructions': 'Instruktionerna',
  'ai.part.nudge': 'Omförsöket: svara bara i JSON',
  'ai.part.public_input': 'Ett hjälpavsnitt som följer med Pascal',
  'ai.part.work_text': 'Organisationens text, inom ett staket',
  'ai.ref.item': 'Ett kort, som det löd då (fingeravtryck {sha}…)',
  'ai.ref.sprint': 'En sprints problem och lärdomar (fingeravtryck {sha}…)',
  'ai.ref.board': 'En tavlas team, etiketter, typer, sprintar och epics (fingeravtryck {sha}…)',
  'ai.ref.question': 'Din fråga, sparad bara som ett fingeravtryck ({sha}…)',
  'ai.proposal.count': '{n} förslag',
  'ai.proposal.count.one': '1 förslag',
  'ai.proposal.kind.breakdown': 'Föreslagna deluppgifter',
  'ai.proposal.kind.draft': 'Föreslaget utkast till kortet',
  'ai.proposal.kind.retro': 'Utkast till sammanfattning',
  'ai.proposal.state.proposed': 'väntar på en person',
  'ai.proposal.state.accepted': 'godtaget',
  'ai.proposal.state.rejected': 'avvisat',
  'ai.proposal.by': 'begärt av {name}, {when}',
  'ai.proposal.choose': 'Välj de deluppgifter som ska skapas',
  'ai.proposal.made': 'Skapade kort: {codes}',
  'ai.proposal.decidedBy': 'Beslutat av {name}',
  'ai.proposal.reason': 'Varför: {reason}',
  'ai.proposal.acceptChosen': 'Skapa de valda deluppgifterna',
  'ai.proposal.acceptDraft': 'Använd rubriken och beskrivningen',
  'ai.proposal.keep': 'Behåll som vårt utkast',
  'ai.proposal.reject': 'Avvisa',
  'ai.proposal.why': 'Varför det avvisas',
  'ai.proposal.rejectSend': 'Avvisa förslaget',
  'ai.item.title': 'AI på kortet',
  'ai.item.breakdown': 'Dela upp med AI',
  'ai.item.draft': 'Skriv utkast med AI',
  'ai.item.proposeNote': 'AI föreslår; du bestämmer. Ingen tilldelas och inget datum eller uppskattning sätts.',
  'ai.openIn': 'Öppna i {product}',
  'ai.openIn.note': 'Länken öppnar produktens egen vy med kortets kod. Ingenting skickas; du gör arbetet där, med dess egen inloggning och regler.',
  'ai.retro.title': 'Utkast till sammanfattning av AI',
  'ai.retro.intro': 'En modell kan skriva ett utkast till sammanfattning av sprintens problem och lärdomar. Det är ett utkast, det nämner ingen och innehåller inga siffror: varje antal på sidan är tavlans eget.',
  'ai.retro.draft': 'Skriv ett utkast med AI',
  'ai.retro.draftLabel': 'Utkast skrivet av en modell, utifrån problemen och lärdomarna som de skrevs',
  'ask.title': 'Fråga Pascal',
  'ask.intro': 'Fråga hur något fungerar, eller hitta kort på en tavla. Svar om arbetet räknas av tavlan, aldrig av en modell.',
  'ask.modes': 'Vad du vill fråga',
  'ask.mode.help': 'Hur gör jag…?',
  'ask.mode.find': 'Hitta…',
  'ask.help.question': 'Din fråga',
  'ask.help.hint': 'Pascal söker i sin egen hjälp. Ingenting skickas någonstans.',
  'ask.help.search': 'Sök i hjälpen',
  'ask.help.none': 'Hjälpen har inget avsnitt om det. Prova andra ord, eller öppna Så fungerar Pascal.',
  'ask.help.answer': 'Pascals svar',
  'ask.help.answerNote': 'Skrivet av en modell utifrån hjälpavsnitten nedan, och bara utifrån dem.',
  'ask.help.cites': 'Använda avsnitt: {ids}',
  'ask.help.section': 'Hjälpavsnitt {id}',
  'ask.help.sheet': 'Se det på sitt blad',
  'ask.help.askModel': 'Be Pascal svara med några meningar',
  'ask.find.intro': 'Pascal gör om din fråga till ett filter för en tavla; tavlan räknar korten med samma regel som sin listvy. Ett filter nämner aldrig en person.',
  'ask.find.guest': 'Att hitta med AI är för organisationens medlemmar.',
  'ask.find.noBoards': 'Du ser ingen tavla ännu.',
  'ask.find.board': 'Tavla',
  'ask.find.question': 'Vad letar du efter?',
  'ask.find.hint': 'Till exempel: vad är försenat i KYC-teamet?',
  'ask.find.ask': 'Hitta',
  'ask.find.result': 'Filtret som Pascal föreslår',
  'ask.find.count': '{n} av tavlans {total} kort matchar',
  'ask.find.count.one': '1 av tavlans {total} kort matchar',
  'ask.find.rule': 'Räknat av tavlan med {rule}, listvyns egen regel.',
  'ask.find.late': 'Försenade',
  'ask.find.mode': 'Utförs av: {mode}',
  'ask.find.type': 'Typ: {type}',
  'ask.find.label': 'Etikett: {label}',
  'ask.find.words': 'Ord: {q}',
  'ask.find.unit': 'Personer i {unit}',
  'ask.find.epic': 'Under epicen {epic}',
  'ask.find.sprint': 'I {sprint}',
  'ask.find.noSprint': 'Utan sprint',
  'ask.find.open': 'Öppna tavlan',
  'ask.find.save': 'Spara som mitt filter',
  'ask.find.saved': 'Sparat. Det finns bland dina filter på tavlan.',
  'how.title': 'Så fungerar Pascal',
  'how.intro': 'Sex blad: klicka på en ruta för att se vad den är, var den finns och vilka tabeller som håller den, eller stega genom ett blad. Inget här räknar något: det gör skärmarna.',
  'how.print': 'Ladda ned för utskrift (A3)',
  'how.sheets': 'Blad',
  'how.stepStart': 'Stega igenom',
  'how.stepBack': 'Föregående',
  'how.stepNext': 'Nästa',
  'how.stepOf': 'Steg {i} av {total}',
  'how.where': 'Var:',
  'how.tables': 'Tabeller:',
  'ai.settings.title': 'AI i organisationen',
  'ai.settings.intro': 'Pascals egen AI delar upp epics, skriver utkast till intagskort och retrospektiv och svarar i Fråga Pascal. Den föreslår bara; en person bestämmer. Den läser aldrig en persons historik, betyg eller arbetsbelastning.',
  'ai.settings.state': 'Läget för AI',
  'ai.settings.allowance': 'AI-tillåtelse',
  'ai.settings.on': 'På',
  'ai.settings.off': 'Av',
  'ai.settings.notNeeded': 'Behövs inte: en deklarerat påhittad organisation',
  'ai.settings.engine': 'Motor på servern',
  'ai.settings.engineReady': 'Inställd',
  'ai.settings.engineMissing': 'Inte inställd (fråga den som driver servern)',
  'ai.settings.available': 'AI kan köras nu',
  'ai.settings.yes': 'Ja',
  'ai.settings.no': 'Nej',
  'ai.settings.caps': 'Kostnadstak och förbrukning',
  'ai.settings.capOrgDay': 'Organisationen, per dag',
  'ai.settings.capPersonDay': 'Varje person, per dag',
  'ai.settings.capOrgMonth': 'Organisationen, per månad',
  'ai.settings.noCap': 'Inget tak',
  'ai.settings.spentMine': 'Du i dag',
  'ai.settings.spentOrgDay': 'Organisationen i dag',
  'ai.settings.spentOrgMonth': 'Organisationen denna månad',
  'ai.settings.capsNote': 'Varje anrop reserverar det mesta det kan kosta innan det skickas; ett anrop som skulle passera ett tak avvisas. Dagar och månader räknas i UTC. Ingen ser en annan persons kostnad.',
  'ai.settings.turnOn': 'Slå på AI',
  'ai.settings.turnOff': 'Stäng av AI',
  'ai.settings.onIntro': 'När AI slås på skickas organisationens text, när en person ber om det, till Claude via Anthropics API. Registrera att organisationen godtar den behandlingen, och på vilken grund.',
  'ai.settings.offIntro': 'När AI stängs av stoppas varje anrop direkt, även ett som väntar på att skickas. Säg varför.',
  'ai.settings.statement': 'Vad organisationen godtar',
  'ai.settings.why': 'Varför',
  'ai.settings.history': 'Ändringar',
  'ai.settings.turnedOn': 'Påslagen av {name}, {when}',
  'ai.settings.turnedOff': 'Avstängd av {name}, {when}',
  'errors.AI_REFUSED': 'Detta skickades inte till någon modell. Ingenting lämnade Pascal.',
  'errors.AI_NOT_CONFIGURED': 'Ingen AI-motor är inställd på servern.',
  'errors.DAILY_SPEND_CAP': 'Dagens AI-budget är slut. Den öppnar igen i morgon (UTC).',
  'errors.MONTHLY_SPEND_CAP': 'Månadens AI-budget är slut.',
  'errors.MODEL_REPLY_UNREADABLE': 'Modellens svar gick inte att använda, så ingenting föreslogs. Försök igen.',
  'errors.MODEL_UNAVAILABLE': 'Modellen kunde inte svara just nu. Försök igen senare.',
  'errors.AI_TARGET': 'AI kan inte göra det här: dela upp en epic, eller skriv utkast till ett kort i intagsfilen.',
  'errors.AI_ROLE': 'Detta kräver en medlem eller administratör i organisationen.',
  'errors.PROPOSAL_DECIDED': 'Det här förslaget är redan beslutat.',
  'errors.ALLOWANCE_STATEMENT': 'Skriv vad organisationen godtar, eller varför AI stängs av (minst 10 tecken).',
  'how.onion.title': 'Löken',
  'how.onion.intro': 'En organisation, dess divisioner och team, och två sätt som arbetet summeras på.',
  'how.onion.organisation.title': 'Organisationen',
  'how.onion.organisation.what': 'Det yttersta lagret. Varje rad i Pascal hör till en organisation, och ingen ser en annan organisations rader.',
  'how.onion.division.title': 'Divisioner',
  'how.onion.division.what': 'Lagret under organisationen. En division har ledare och medlemmar och äger projekt.',
  'how.onion.team.title': 'Team',
  'how.onion.team.what': 'Lagret under en division. En person har ett hemteam och kan tillhöra andra.',
  'how.onion.peoplePath.title': 'Gjort av personer här',
  'how.onion.peoplePath.what': 'Första vägen upp: korten som personer med hemvist i enheten utförde, var projektet än finns. Visas bara för minst fem personer.',
  'how.onion.projectPath.title': 'Arbete i projekt som ägs här',
  'how.onion.projectPath.what': 'Andra vägen upp: korten i de projekt enheten äger, vem som än gjorde dem. Projekt du inte ser räknas, men namnges aldrig.',
  'how.item-life.title': 'Ett korts liv',
  'how.item-life.intro': 'Från en begäran till klart, med de grindar en person måste passera.',
  'how.item-life.intake.title': 'Intag',
  'how.item-life.intake.what': 'Begäranden kommer hit, inskrivna eller inhämtade från familjen. Pascals AI kan skriva ett tydligare utkast; en person bestämmer.',
  'how.item-life.backlog.title': 'Backlogg',
  'how.item-life.backlog.what': 'Rangordnat arbete som väntar på att börja. En epic kan delas upp i föreslagna deluppgifter.',
  'how.item-life.active.title': 'Pågår',
  'how.item-life.active.what': 'Arbete som pågår. Den första uppskattningen fryses som baslinje när kortet först kommer hit.',
  'how.item-life.review.title': 'Granskning',
  'how.item-life.review.what': 'Någon tittar på arbetet innan det är klart.',
  'how.item-life.done.title': 'Klart',
  'how.item-life.done.what': 'Klart kräver ett utfall och en person som bekräftar: den som är inloggad. En AI-expert bekräftar aldrig.',
  'how.item-life.fourEyes.title': 'Fyra ögon',
  'how.item-life.fourEyes.what': 'En kontrolluppgift kräver en andra person, varken utförare eller bekräftare. Databasen upprätthåller det.',
  'how.who-did.title': 'Vem gjorde arbetet',
  'how.who-did.intro': 'En person, en AI-expert i familjen, eller ett par; och vad en AI bidrog med.',
  'how.who-did.person.title': 'En person',
  'how.who-did.person.what': 'Utför kortet. Namnet finns på arbetsposten; hur det kändes förblir personens eget.',
  'how.who-did.aiExpert.title': 'En AI-expert',
  'how.who-did.aiExpert.what': 'ANTON, Valentin, Gabriel och de andra kan utföra ett kort. De föreslår; de äger, bekräftar eller granskar det aldrig.',
  'how.who-did.pair.title': 'Ett par',
  'how.who-did.pair.what': 'En person och en AI-expert tillsammans. Lärandevyn jämför hur par gick, som en jämförelse och inte en orsak.',
  'how.who-did.receipt.title': 'Bidragskvittot',
  'how.who-did.receipt.what': 'En person gör AI-arbetet i syskonprodukten själv, öppnad från kortet, och registrerar vad som gick in och vad det kostade.',
  'how.who-did.ownAi.title': 'Pascals egen AI',
  'how.who-did.ownAi.what': 'Delar upp epics, skriver utkast till kort och sammanfattningar, svarar i Fråga Pascal. Varje svar är ett förslag, med förhandsvisning före och en post efter.',
  'how.learning-loop.title': 'Lärandeslingan',
  'how.learning-loop.intro': 'Uppskattning, utfall, kalibrering, problem och retrospektivet.',
  'how.learning-loop.baseline.title': 'Baslinjen',
  'how.learning-loop.baseline.what': 'Den första uppskattningen, fryst när arbetet börjar. En ny uppskattning är en ny siffra bredvid, med ett skäl.',
  'how.learning-loop.actual.title': 'Utfallet',
  'how.learning-loop.actual.what': 'Hur lång tid det verkligen tog, i grova steg. Det är ingen tidrapport.',
  'how.learning-loop.calibration.title': 'Kalibrering',
  'how.learning-loop.calibration.what': 'Kod jämför uppskattningar och utfall. Under åtta kort säger den ingenting; du ser ditt eget förslag, ingen annans.',
  'how.learning-loop.problems.title': 'Problem',
  'how.learning-loop.problems.what': 'Utan skuld: vad som gick fel, hur det upptäcktes och löstes, vad man kan prova nästa gång.',
  'how.learning-loop.retro.title': 'Retrospektivet',
  'how.learning-loop.retro.what': 'Där lärandet diskuteras. En modell kan skriva ett utkast utifrån texterna; antalen bredvid är tavlans.',
  'how.family.title': 'Familjen',
  'how.family.intro': 'Filer in, status ut, och vem som äger vad.',
  'how.family.fileIn.title': 'En fil in',
  'how.family.fileIn.what': 'En annan produkt i familjen exporterar en fil; en person tar in den. Ingenting kommer av sig självt.',
  'how.family.intakeLane.title': 'Intagsfilen',
  'how.family.intakeLane.what': 'Varje post blir ett förslag. Dess text är data, aldrig instruktioner.',
  'how.family.accept.title': 'Godta',
  'how.family.accept.what': 'En ledare eller medlem i projektet gör den till ett kort, eller avvisar den med ett skäl.',
  'how.family.statusOut.title': 'Status ut',
  'how.family.statusOut.what': 'Pascal skriver en statusfil att bära tillbaka. Den stänger aldrig något i den andra produkten.',
  'how.family.owners.title': 'Vem äger vad',
  'how.family.owners.what': 'Källan äger sin post och sin avslutning; Pascal äger planeringen.',
  'how.your-data.title': 'Dina uppgifter',
  'how.your-data.intro': 'Vad som bara är ditt, vad som bara visas i grupper om fem, och vad en modell får.',
  'how.your-data.ownRatings.title': 'Bara ditt',
  'how.your-data.ownRatings.what': 'Hur ett kort kändes för dig ses bara av dig, vilken roll någon än har.',
  'how.your-data.groupSize.title': 'Grupper om fem',
  'how.your-data.groupSize.what': 'En gruppsiffra kräver fem olika personer och en period som har tagit slut; det som subtraktion skulle avslöja döljs.',
  'how.your-data.noRanking.title': 'Ingen rangordning',
  'how.your-data.noRanking.what': 'Ingen vy rangordnar personer och det finns inget prestationsbetyg. Ingen modell föreslår vem som ska göra ett kort eller läser en persons historik.',
  'how.your-data.aiRecords.title': 'Vad en modell får',
  'how.your-data.aiRecords.what': 'Bara det uppgiften behöver, inom staket som data. Pascal sparar ett fingeravtryck av din text, aldrig texten, och du kan se vad som skickades.',
  'how.your-data.erase.title': 'Radera',
  'how.your-data.erase.what': 'Du kan radera dina egna svar; gruppsiffrorna de räknades i räknas om utan dem.',

  // ── P7: privacy pack, leavers, recurring work, templates, intake forms, import ─────────────────────────────
  'nav.privacyPack': 'Integritetspaket',
  'nav.wheel': 'Årshjul',
  'nav.import': 'Importera',
  'nav.intake': 'Fråga ett team',
  'p7.project': 'Projekt',
  'p7.board': 'Tavla',
  'p7.noProjects': 'Du ser inget projekt ännu.',
  'pack.title': 'Integritetspaket',
  'pack.intro': 'Dina egna uppgifter att ladda ned, och de dokument en arbetsgivare fyller i innan Pascal används med riktiga anställda.',
  'pack.draft': 'UTKAST: behöver juridisk granskning. Inte juridisk rådgivning.',
  'pack.read': 'Läs dokumentet',
  'pack.download': 'Ladda ned {file}',
  'pack.lang.en': 'På engelska',
  'pack.lang.sv': 'På svenska',
  'mydata.title': 'Dina uppgifter',
  'mydata.intro': 'Allt Pascal har om dig: ditt konto, dina roller och team, korten du utför, rapporterat eller äger, dina kommentarer och problem, dina egna svar, dina planerade timmar och dina AI-anrop. Bara dina, vilken roll du än har.',
  'mydata.download': 'Ladda ned mina uppgifter',
  'mydata.downloadCsv': 'Ladda ned som CSV',
  'mydata.withheld': 'Ett kort i ett projekt du inte längre ser listas med sin kod, utan rubrik. Fråga din organisation om du behöver mer.',
  'leaver.title': 'Avslut',
  'leaver.intro': 'Kontot stängs av på sista dagen. Personens svar raderas 30 dagar senare. Namnet står kvar på arbetet tills du ersätter det med en pseudonym, vilket inte går att ångra.',
  'leaver.person': 'Vem',
  'leaver.day': 'Sista dag',
  'leaver.reason': 'Varför',
  'leaver.record': 'Registrera avslut',
  'leaver.recorded': 'Avslutet är registrerat.',
  'leaver.pseudonymise': 'Ersätt namnet med en pseudonym',
  'leaver.pseudonymiseConfirm': 'Ersätta namnet {name} med en pseudonym? Det går inte att ångra.',
  'leaver.pseudonymised': 'Namnet har ersatts.',
  'leaver.leftOn': 'slutade {day}',
  'wheel.title': 'Årshjul',
  'wheel.intro': 'Årets återkommande uppgifter, månad för månad: korten som redan finns och dagarna som är kvar.',
  'wheel.previous': 'Föregående år',
  'wheel.next': 'Nästa år',
  'wheel.yearTitle': 'Året {year}',
  'wheel.counts': 'Kort som finns: {cards}. Kvar att komma: {toCome}.',
  'wheel.figure': 'Årshjulet för {year}: antalet återkommande uppgifter i varje månad',
  'wheel.tableCaption': 'Återkommande uppgifter {year}, per månad',
  'wheel.month': 'Månad',
  'wheel.duties': 'Uppgifter',
  'wheel.none': 'Inga',
  'wheel.card': 'kort {code}',
  'wheel.toCome': 'kommer',
  'series.title': 'Återkommande arbete',
  'series.none': 'Projektet har inget återkommande arbete ännu.',
  'series.cards': '{n} kort',
  'series.cards.one': '1 kort',
  'series.from': 'från {day}',
  'series.status.active': 'Aktiv',
  'series.status.paused': 'Pausad',
  'series.status.retired': 'Avslutad',
  'series.pause': 'Pausa',
  'series.resume': 'Återuppta',
  'series.retire': 'Avsluta',
  'series.retireConfirm': 'Avsluta "{title}"? Inga nya kort skapas och den kan inte återupptas; korten finns kvar.',
  'series.leadOnly': 'Projektledaren lägger upp återkommande arbete.',
  'series.new': 'Nytt återkommande arbete',
  'series.field.title': 'Rubrik på varje kort',
  'series.field.basis': 'Varför det finns',
  'series.field.basisHint': 'En regel, en policy eller ett avtal; visas på varje kort.',
  'series.field.type': 'Typ av kort',
  'series.field.rule': 'Hur ofta',
  'series.field.startsOn': 'Första dag',
  'series.field.roll': 'På en helg',
  'series.field.prepDays': 'Dagar att förbereda (kortet börjar så många dagar före förfallodagen)',
  'series.type.duty': 'Återkommande uppgift',
  'series.type.control': 'Kontroll (fyra ögon)',
  'series.type.task': 'Uppgift',
  'series.type.remediation': 'Åtgärd (fyra ögon)',
  'series.type.milestone': 'Milstolpe',
  'series.rule.monthly15': 'Varje månad den 15:e',
  'series.rule.monthlyFirst': 'Varje månad den 1:a',
  'series.rule.monthlyLastFriday': 'Varje månad sista fredagen',
  'series.rule.quarterly': 'Varje kvartal den 1:a',
  'series.rule.yearly': 'Varje år på första dagen',
  'series.rule.weeklyMonday': 'Varje måndag',
  'series.roll.next_business_day': 'Flytta till nästa vardag',
  'series.roll.previous_business_day': 'Flytta till vardagen före',
  'series.roll.none': 'Behåll dagen',
  'series.save': 'Lägg upp',
  'series.made': '{n} kort skapade för de kommande 12 månaderna.',
  'series.made.one': '1 kort skapat för de kommande 12 månaderna.',
  'import.title': 'Importera',
  'import.intro': 'Hämta in kort från en CSV-fil: kontrollera den först, inget sparas; importera den sedan en gång. Varje kort hamnar öppet i inkorgen.',
  'import.noProjects': 'Du skriver inte i något projekt ännu, så det finns inget att importera till.',
  'import.csvTitle': 'En CSV-fil',
  'import.preset': 'Var filen kommer ifrån',
  'import.preset.jira': 'Jira (CSV-export)',
  'import.preset.monday': 'Monday (CSV sparad från Excel-exporten)',
  'import.preset.pascal': 'Pascals egna kolumner',
  'import.presetHint.jira': 'Summary, Issue Type, Status, Priority, Description, Due date, Labels, Original Estimate och Parent id läses.',
  'import.presetHint.monday': 'Name, Status, Priority, Date och Notes läses; varje grupp blir en etikett.',
  'import.presetHint.pascal': 'title, description, type, priority, due_on, estimate_hours och labels (åtskilda med ;) läses.',
  'import.file': 'Fil',
  'import.rules': 'Kort som är stängda i källan importeras inte. Personer importeras aldrig: tilldela dem i Pascal.',
  'import.dryRun': 'Kontrollera först (inget sparas)',
  'import.run': 'Importera',
  'import.created': '{n} kort importerade.',
  'import.created.one': '1 kort importerat.',
  'import.report.title': 'Vad filen innehåller',
  'import.report.rows': '{n} rader lästa',
  'import.report.rows.one': '1 rad läst',
  'import.report.toCreate': '{n} kort att skapa',
  'import.report.toCreate.one': '1 kort att skapa',
  'import.report.closed': '{n} stängda i källan: importeras inte',
  'import.report.closed.one': '1 stängd i källan: importeras inte',
  'import.report.refused': '{n} rader avvisade',
  'import.report.refused.one': '1 rad avvisad',
  'import.report.unknownTypes': '{n} av okänd typ, importeras som uppgifter',
  'import.report.unknownTypes.one': '1 av okänd typ, importeras som uppgift',
  'import.report.unreadDates': '{n} datum kunde inte läsas och lämnas tomma',
  'import.report.unreadDates.one': '1 datum kunde inte läsas och lämnas tomt',
  'import.report.groups': '{n} grupper',
  'import.report.groups.one': '1 grupp',
  'import.report.refusedRow': 'Rad {row}: {reason}',
  'import.reason.no_title': 'ingen rubrik',
  'import.reason.title_too_long': 'rubriken är längre än 200 tecken',
  'import.report.ignored': 'Lästes inte: {columns}',
  'import.report.nothingSaved': 'Inget har sparats.',
  'template.title': 'Mallar',
  'template.choose': 'Mall',
  'template.kind.project': 'en projektplan',
  'template.kind.checklist': 'en checklista under ett kort',
  'template.items': '{n} kort',
  'template.items.one': '1 kort',
  'template.under': 'Under kortet',
  'template.pickCard': 'Välj ett kort',
  'template.startOn': 'Startdag',
  'template.startOnHint': 'Frivilligt: förfallodagarna räknas från den.',
  'template.apply': 'Använd mallen',
  'template.made': '{n} kort skapade.',
  'template.made.one': '1 kort skapat.',
  'intake.title': 'Fråga ett team',
  'intake.intro': 'Skicka en förfrågan till ett team utan e-post. Den hamnar i teamets inkorg, och du kan följa den här.',
  'intake.fcpLine': 'Namnge inte kunder. Använd ärendereferensen från ert ärendesystem.',
  'intake.noForms': 'Inget team tar emot förfrågningar från dig här ännu.',
  'intake.field.title': 'Vad behöver du?',
  'intake.field.description': 'Detaljer',
  'intake.field.dueOn': 'Behövs senast',
  'intake.field.priority': 'Prioritet',
  'intake.send': 'Skicka förfrågan',
  'intake.sent': 'Skickad som {code}.',
  'intake.mine': 'Dina förfrågningar',
  'intake.mineNone': 'Du har inte skickat någon förfrågan.',
  'intake.manage': 'Formulär i projekten du leder',
  'intake.forms': 'Formulär',
  'intake.formsNone': 'Projektet har inget formulär ännu.',
  'intake.status.open': 'Öppet',
  'intake.status.closed': 'Stängt',
  'intake.open': 'Öppna det',
  'intake.close': 'Stäng det',
  'intake.who.organisation': 'Alla i organisationen',
  'intake.who.members': 'Bara projektets medlemmar',
  'intake.newForm': 'Nytt formulär',
  'intake.formTitle': 'Formulärets namn',
  'intake.formIntro': 'En rad till den som frågar',
  'intake.whoField': 'Vem som får skicka',
  'intake.fieldsAsked': 'Fråga också',
  'intake.fieldName.description': 'detaljer',
  'intake.fieldName.due_on': 'behövs senast',
  'intake.fieldName.priority': 'prioritet',
  'intake.createForm': 'Lägg upp formuläret',
  'errors.LEAVER_OWN': 'Ingen registrerar sitt eget avslut eller sin egen pseudonym.',
  'errors.LEAVER_DAY': 'Sista dagen ligger högst ett år fram.',
  'errors.LEAVER_REASON': 'Ange varför, med minst 3 tecken.',
  'errors.PSEUDONYMISE_NOT_LEFT': 'Bara en person som har slutat kan få en pseudonym.',
  'errors.PSEUDONYMISED': 'Personen har redan en pseudonym.',
  'errors.MYDATA_NO_PARAMETERS': 'Dina uppgifter är alltid dina egna: detta tar ingen parameter.',
  'errors.SERIES_RULE': 'Pascal kan inte läsa regeln. Välj en regel per vecka, månad eller år.',
  'errors.SERIES_TOO_OFTEN': 'Ett återkommande kort kommer högst en gång i veckan.',
  'errors.SERIES_RETIRED': 'Det återkommande arbetet är avslutat.',
  'errors.SERIES_STARTS': 'Första dagen ligger inom tio år.',
  'errors.TEMPLATE_UNKNOWN': 'Det finns ingen sådan mall.',
  'errors.TEMPLATE_LOCK': 'Mallen har ändrats sedan den kontrollerades, så den används inte.',
  'errors.TEMPLATE_KIND': 'En checklista hamnar under ett kort; en projektplan på en tavla.',
  'errors.INTAKE_CLOSED': 'Formuläret är stängt.',
  'errors.INTAKE_NOT_FOR_YOU': 'Formuläret är för projektets medlemmar.',
  'errors.IMPORT_CSV': 'Filen kan inte läsas som CSV: ett citerat fält avslutas aldrig.',
  'errors.IMPORT_EMPTY': 'Inget i filen skulle bli ett kort.',
  'errors.IMPORT_TOO_MANY': 'Högst 2 000 rader och 5 MB åt gången.',
  'errors.IMPORT_DUPLICATE': 'Filen har redan importerats till projektet.',
}
